var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 704.4 517.6",
    style: {
      enableBackground: "new 0 0 704.4 517.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#53A9FF;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#1A1332;}\n\t.st3{fill:#1D2431;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1212_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_311_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_520_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1341_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1728_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_902_",
    className: "st0",
    d: "M159.9,342.5L134,357.5c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l25.9-14.9c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C160.4,341.6,160.4,342.2,159.9,342.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_903_",
    className: "st1",
    d: "M133,358.3c-0.6,0-1.1-0.1-1.6-0.4l-10-5.8c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.8,0.7-1.1l25.9-14.9c0.8-0.4,2-0.4,2.9,0.1l10,5.7c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.8-0.7,1.1v0L134.3,358 C134,358.2,133.5,358.3,133,358.3z M148.5,335.8c-0.3,0-0.5,0.1-0.7,0.1l-25.9,14.9c-0.1,0,0,0.1,0.2,0.2l10,5.8 c0.5,0.3,1.3,0.3,1.6,0.1l25.9-14.9c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.7C149.1,335.9,148.8,335.8,148.5,335.8 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1727_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_898_",
    className: "st0",
    d: "M314.1,253.5l-43.2,24.9c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l43.2-24.9c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C314.6,252.6,314.7,253.2,314.1,253.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_899_",
    className: "st1",
    d: "M269.9,279.3c-0.6,0-1.1-0.1-1.6-0.4l-10-5.8c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.8,0.7-1.1l43.2-24.9c0.8-0.4,2-0.4,2.9,0.1l10,5.8c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.8-0.7,1.1L271.2,279 C270.8,279.2,270.4,279.3,269.9,279.3z M302.7,246.7c-0.3,0-0.5,0.1-0.7,0.1l-43.2,24.9c-0.1,0,0,0.1,0.2,0.2l10,5.8 c0.5,0.3,1.3,0.3,1.7,0.1l43.2-24.9c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.8C303.4,246.8,303,246.7,302.7,246.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1726_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_894_",
    className: "st1",
    d: "M229.2,302.5l-2.4,1.4c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l2.4-1.4c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C229.7,301.6,229.8,302.2,229.2,302.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_895_",
    className: "st1",
    d: "M225.8,304.8c-0.6,0-1.1-0.1-1.6-0.4l-10-5.7c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.8,0.7-1.1l2.4-1.4c0.8-0.4,2-0.4,2.9,0.1l10,5.8c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.8-0.7,1.1l-2.4,1.4 C226.7,304.7,226.2,304.8,225.8,304.8z M217.8,295.8c-0.3,0-0.5,0.1-0.7,0.1l-2.4,1.4c-0.1,0,0,0.1,0.2,0.2l10,5.7 c0.5,0.3,1.3,0.3,1.6,0.1l2.4-1.4c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.8C218.5,295.8,218.1,295.8,217.8,295.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1725_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_890_",
    className: "st0",
    d: "M351.9,253.7l-2.4,1.4c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l2.4-1.4c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C352.4,252.8,352.4,253.4,351.9,253.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_891_",
    className: "st1",
    d: "M348.5,255.9c-0.6,0-1.1-0.1-1.6-0.4l-10-5.8c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.8,0.7-1.1l2.4-1.4c0.8-0.4,2-0.4,2.9,0.1l10,5.8c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.8-0.7,1.1l-2.4,1.4 C349.4,255.8,348.9,255.9,348.5,255.9z M340.5,246.9c-0.3,0-0.5,0.1-0.7,0.1l-2.4,1.4c-0.1,0,0,0.1,0.2,0.2l10,5.8 c0.5,0.3,1.3,0.3,1.7,0.1l2.4-1.4c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.8C341.1,247,340.8,246.9,340.5,246.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1724_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_886_",
    className: "st0",
    d: "M212.1,312.4l-15.9,9.2c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l15.9-9.2c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C212.6,311.4,212.7,312,212.1,312.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_887_",
    className: "st1",
    d: "M195.2,322.4c-0.6,0-1.1-0.1-1.6-0.4l-10-5.8c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.8,0.7-1.1l15.9-9.2c0.8-0.4,2-0.4,2.9,0.1l10,5.7c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.8-0.7,1.1l-15.9,9.2 C196.1,322.3,195.7,322.4,195.2,322.4z M200.7,305.6c-0.3,0-0.5,0.1-0.7,0.1l-15.9,9.2c-0.1,0,0,0.1,0.2,0.2l10,5.8 c0.5,0.3,1.3,0.3,1.7,0.1l15.9-9.2c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.7C201.4,305.7,201,305.6,200.7,305.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1723_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_882_",
    className: "st0",
    d: "M354.5,274.6l-1.6,0.9c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l1.6-0.9c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C355.1,273.7,355.1,274.3,354.5,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_883_",
    className: "st1",
    d: "M351.9,276.4c-0.6,0-1.1-0.1-1.6-0.4l-10-5.8c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.9,0.7-1.1l1.6-0.9c0.8-0.4,2-0.4,2.9,0.1l10,5.8c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.8-0.7,1.1l-1.6,0.9 C352.9,276.3,352.4,276.4,351.9,276.4z M343.1,267.8c-0.3,0-0.5,0.1-0.7,0.1l-1.6,0.9c-0.1,0,0,0.1,0.2,0.2l10,5.8 c0.5,0.3,1.3,0.3,1.7,0.1l1.6-0.9c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.8C343.8,267.9,343.5,267.8,343.1,267.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1722_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_878_",
    className: "st1",
    d: "M377.5,216.9l-0.2,0.1c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l0.2-0.1c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C378,216,378.1,216.6,377.5,216.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_879_",
    className: "st1",
    d: "M376.3,217.8c-0.6,0-1.1-0.1-1.6-0.4l-10-5.8c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.8,0.7-1.1l0.2-0.1c0.8-0.4,2-0.4,2.9,0.1l10,5.8c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.8-0.7,1.1l-0.2,0.1 C377.3,217.7,376.8,217.8,376.3,217.8z M366.1,210.1c-0.3,0-0.5,0.1-0.7,0.1l-0.2,0.1c-0.1,0,0,0.1,0.2,0.2l10,5.8 c0.5,0.3,1.3,0.3,1.7,0.1l0.2-0.1c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.8C366.8,210.2,366.4,210.1,366.1,210.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1721_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_874_",
    className: "st1",
    d: "M189.7,325.3l-0.2,0.1c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l0.2-0.1c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C190.2,324.4,190.2,325,189.7,325.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_875_",
    className: "st1",
    d: "M188.5,326.3c-0.6,0-1.1-0.1-1.6-0.4l-10-5.7c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.8,0.7-1.1l0.2-0.1c0.8-0.4,2-0.4,2.9,0.1l10,5.8c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.8-0.7,1.1l-0.2,0.1 C189.5,326.2,189,326.3,188.5,326.3z M178.3,318.6c-0.3,0-0.5,0.1-0.7,0.1l-0.2,0.1c-0.1,0,0,0.1,0.2,0.2l10,5.7 c0.5,0.3,1.3,0.3,1.7,0.1l0.2-0.1c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.8C178.9,318.6,178.6,318.6,178.3,318.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1720_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_870_",
    className: "st1",
    d: "M425.4,211.2l-0.2,0.1c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l0.2-0.1c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C425.9,210.3,426,210.9,425.4,211.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_871_",
    className: "st1",
    d: "M424.2,212.2c-0.6,0-1.1-0.1-1.6-0.4l-10-5.8c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.8,0.7-1.1l0.2-0.1c0.8-0.4,2-0.4,2.9,0.1l10,5.8c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.8-0.7,1.1l-0.2,0.1 C425.2,212.1,424.7,212.2,424.2,212.2z M414,204.5c-0.3,0-0.5,0.1-0.7,0.1l-0.2,0.1c-0.1,0,0,0.1,0.2,0.2l10,5.8 c0.5,0.3,1.3,0.3,1.6,0.1l0.2-0.1c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.8C414.7,204.6,414.3,204.5,414,204.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1719_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_866_",
    className: "st1",
    d: "M418.7,215.1l-0.2,0.1c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l0.2-0.1c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C419.2,214.2,419.2,214.8,418.7,215.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_867_",
    className: "st1",
    d: "M417.5,216.1c-0.6,0-1.1-0.1-1.6-0.4l-10-5.8c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.8,0.7-1.1l0.2-0.1c0.8-0.4,2-0.4,2.9,0.1l10,5.8c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.8-0.7,1.1l-0.2,0.1 C418.4,216,418,216.1,417.5,216.1z M407.2,208.4c-0.3,0-0.5,0.1-0.7,0.1l-0.2,0.1c-0.1,0,0,0.1,0.2,0.2l10,5.8 c0.5,0.3,1.3,0.3,1.7,0.1l0.2-0.1c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.8C407.9,208.4,407.6,208.4,407.2,208.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1718_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_862_",
    className: "st1",
    d: "M160,386.5l-0.2,0.1c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3l0.2-0.1 c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C160.5,385.5,160.6,386.1,160,386.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_863_",
    className: "st1",
    d: "M158.9,387.4c-0.6,0-1.1-0.1-1.6-0.4l-10-5.7c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.8,0.7-1.1l0.2-0.1c0.8-0.4,2-0.4,2.9,0.1l10,5.7c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.8-0.7,1.1v0l-0.2,0.1 C159.8,387.3,159.3,387.4,158.9,387.4z M148.6,379.7c-0.3,0-0.5,0.1-0.7,0.1l-0.2,0.1c-0.1,0,0,0.1,0.2,0.2l10,5.7 c0.5,0.3,1.3,0.3,1.7,0.1l0.2-0.1c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.7C149.3,379.8,148.9,379.7,148.6,379.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1717_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_858_",
    className: "st1",
    d: "M258.6,285.5l-21.5,12.4c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l21.5-12.4c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C259.1,284.6,259.2,285.2,258.6,285.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_859_",
    className: "st1",
    d: "M236.1,298.8c-0.6,0-1.1-0.1-1.6-0.4l-10-5.7c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.8,0.7-1.1l21.5-12.4c0.8-0.4,2-0.4,2.9,0.1l10,5.8c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.8-0.7,1.1v0l-21.5,12.4 C237.1,298.7,236.6,298.8,236.1,298.8z M247.2,278.8c-0.3,0-0.5,0.1-0.7,0.1L225,291.3c-0.1,0,0,0.1,0.2,0.2l10,5.7 c0.5,0.3,1.3,0.3,1.7,0.1l21.5-12.4v0c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.2-0.2l-10-5.8 C247.9,278.9,247.5,278.8,247.2,278.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1716_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_854_",
    className: "st1",
    d: "M363.6,224.9l-4.8,2.8c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l4.8-2.8c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C364.1,224,364.2,224.6,363.6,224.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_855_",
    className: "st1",
    d: "M357.8,228.5c-0.6,0-1.1-0.1-1.6-0.4l-10-5.8c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.8,0.7-1.1l4.8-2.7c0.8-0.5,2-0.4,2.9,0.1l10,5.8c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.8-0.7,1.1l-4.8,2.7 C358.8,228.4,358.3,228.5,357.8,228.5z M352.2,218.2c-0.3,0-0.5,0.1-0.7,0.1l-4.8,2.7c-0.1,0,0,0.1,0.2,0.2l10,5.8 c0.5,0.3,1.3,0.3,1.6,0.1l4.8-2.7c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.8C352.8,218.2,352.5,218.2,352.2,218.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1708_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_850_",
    className: "st0",
    d: "M348.2,233.8l-21.5,12.4c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l21.5-12.4c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C348.7,232.9,348.8,233.5,348.2,233.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_851_",
    className: "st1",
    d: "M325.7,247.1c-0.6,0-1.1-0.1-1.6-0.4l-10-5.8c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.8,0.7-1.1l21.5-12.4c0.8-0.4,2-0.4,2.9,0.1l10,5.8c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.8-0.7,1.1L327,246.8 C326.7,247,326.2,247.1,325.7,247.1z M336.8,227c-0.3,0-0.5,0.1-0.7,0.1l-21.5,12.4c-0.1,0,0,0.1,0.2,0.2l10,5.8 c0.5,0.3,1.3,0.3,1.6,0.1l21.5-12.4c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.8C337.5,227.1,337.1,227,336.8,227z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1707_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_846_",
    className: "st0",
    d: "M254.9,309.7l-25,14.4c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l25-14.4c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C255.4,308.7,255.5,309.3,254.9,309.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_847_",
    className: "st1",
    d: "M229,324.9c-0.6,0-1.1-0.1-1.6-0.4l-10-5.8c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.9,0.7-1.1l25-14.4c0.8-0.4,2-0.4,2.9,0.1l10,5.8c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.9-0.7,1.1v0l-25,14.4 C229.9,324.8,229.4,324.9,229,324.9z M243.5,302.9c-0.3,0-0.5,0.1-0.7,0.1l-25,14.4c-0.1,0,0,0.1,0.2,0.2l10,5.8 c0.5,0.3,1.3,0.3,1.7,0.1l25-14.4c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.8C244.2,303,243.8,302.9,243.5,302.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1706_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_842_",
    className: "st1",
    d: "M162.8,362.8l-2.4,1.4c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l2.4-1.4c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C163.3,361.9,163.4,362.5,162.8,362.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_843_",
    className: "st1",
    d: "M159.4,365.1c-0.6,0-1.1-0.1-1.6-0.4l-10-5.7c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.8,0.7-1.1l2.4-1.4c0.8-0.5,2-0.4,2.9,0.1l10,5.7c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.8-0.7,1.1l-2.4,1.4 C160.4,365,159.9,365.1,159.4,365.1z M151.4,356.1c-0.3,0-0.5,0.1-0.7,0.1l-2.4,1.4c-0.1,0,0,0.1,0.2,0.2l10,5.8 c0.5,0.3,1.3,0.3,1.7,0.1l2.4-1.4c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.7C152.1,356.1,151.8,356.1,151.4,356.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1705_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_838_",
    className: "st0",
    d: "M300.3,283.5l-2.4,1.4c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l2.4-1.4c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C300.8,282.5,300.9,283.1,300.3,283.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_839_",
    className: "st1",
    d: "M296.9,285.7c-0.6,0-1.1-0.1-1.6-0.4l-10-5.8c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.9,0.7-1.1l2.4-1.4c0.8-0.4,2-0.4,2.9,0.1l10,5.7c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.8-0.7,1.1v0l-2.4,1.4 C297.8,285.6,297.4,285.7,296.9,285.7z M288.9,276.7c-0.3,0-0.5,0.1-0.7,0.1l-2.4,1.4c-0.1,0,0,0.1,0.2,0.2l10,5.8 c0.5,0.3,1.3,0.3,1.7,0.1l2.4-1.4c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.7C289.6,276.8,289.2,276.7,288.9,276.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1704_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_834_",
    className: "st1",
    d: "M343.1,281.2l-7.7,4.5c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l7.7-4.5c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C343.6,280.3,343.6,280.9,343.1,281.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_835_",
    className: "st1",
    d: "M334.3,286.6c-0.6,0-1.1-0.1-1.6-0.4l-10-5.8c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.8,0.7-1.1l7.7-4.5c0.8-0.4,2-0.4,2.9,0.1l10,5.8c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.8-0.7,1.1v0l-7.7,4.5 C335.3,286.4,334.8,286.6,334.3,286.6z M331.6,274.5c-0.3,0-0.5,0.1-0.7,0.1l-7.7,4.5c-0.1,0,0,0.1,0.2,0.2l10,5.7 c0.5,0.3,1.3,0.3,1.6,0.1l7.7-4.5c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.7C332.3,274.5,332,274.5,331.6,274.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1703_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_830_",
    className: "st1",
    d: "M152.9,368.5l-21.5,12.4c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l21.5-12.4c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C153.5,367.6,153.5,368.2,152.9,368.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_831_",
    className: "st1",
    d: "M130.5,381.8c-0.6,0-1.1-0.1-1.6-0.4l-10-5.8c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.8,0.7-1.1l21.5-12.4c0.8-0.4,2-0.4,2.9,0.1l10,5.8c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.9-0.7,1.1v0l-21.5,12.4 C131.4,381.7,131,381.8,130.5,381.8z M141.5,361.8c-0.3,0-0.5,0.1-0.7,0.1l-21.5,12.4c-0.1,0,0,0.1,0.2,0.2l10,5.8 c0.5,0.3,1.3,0.3,1.7,0.1l21.5-12.4v0c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.8 C142.2,361.9,141.9,361.8,141.5,361.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1702_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_826_",
    className: "st1",
    d: "M226.6,348l-21.5,12.4c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l21.5-12.4c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C227.2,347.1,227.2,347.7,226.6,348z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_827_",
    className: "st1",
    d: "M204.2,361.2c-0.6,0-1.1-0.1-1.6-0.4l-10-5.7c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.8,0.7-1.1l21.5-12.4c0.8-0.4,2-0.4,2.9,0.1l10,5.7c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.8-0.7,1.1l-21.5,12.4 C205.1,361.1,204.7,361.2,204.2,361.2z M215.2,341.2c-0.3,0-0.5,0.1-0.7,0.1l-21.5,12.4c-0.1,0,0,0.1,0.2,0.2l10,5.7 c0.5,0.3,1.3,0.3,1.7,0.1l21.5-12.4c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.7C215.9,341.3,215.6,341.2,215.2,341.2 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1661_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_822_",
    className: "st0",
    d: "M325.5,291.4l-49,28.3c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l49-28.3c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C326,290.5,326,291.1,325.5,291.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_823_",
    className: "st1",
    d: "M275.5,320.5c-0.6,0-1.1-0.1-1.6-0.4l-10-5.8c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.8,0.7-1.1l49-28.3c0.8-0.4,2-0.4,2.9,0.1l10,5.8c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.9-0.7,1.1v0l-49,28.3 C276.4,320.4,276,320.5,275.5,320.5z M314.1,284.6c-0.3,0-0.5,0.1-0.7,0.1l-49,28.3c-0.1,0,0,0.1,0.2,0.2l10,5.8 c0.5,0.3,1.3,0.3,1.7,0.1l49-28.3v0c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.8C314.7,284.7,314.4,284.6,314.1,284.6 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1660_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_818_",
    className: "st0",
    d: "M403.5,246.3L367.7,267c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l35.7-20.6c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C404,245.4,404.1,246,403.5,246.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_819_",
    className: "st1",
    d: "M366.7,267.8c-0.6,0-1.1-0.1-1.6-0.4l-10-5.8c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.9,0.7-1.1l35.7-20.6c0.8-0.4,2-0.4,2.9,0.1l10,5.8c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.8-0.7,1.1L368,267.5 C367.7,267.7,367.2,267.8,366.7,267.8z M392.1,239.6c-0.3,0-0.5,0.1-0.7,0.1l-35.7,20.6c-0.1,0,0,0.1,0.2,0.2l10,5.8 c0.5,0.3,1.3,0.3,1.7,0.1l35.7-20.6c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.8C392.8,239.7,392.4,239.6,392.1,239.6 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1659_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_814_",
    className: "st1",
    d: "M267.6,324.8l-2.9,1.6c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l2.9-1.6c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C268.1,323.9,268.2,324.4,267.6,324.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_815_",
    className: "st1",
    d: "M263.8,327.3c-0.6,0-1.1-0.1-1.6-0.4l-10-5.7c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.8,0.7-1.1l2.8-1.6c0.8-0.4,2-0.4,2.9,0.1l10,5.7c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.8-0.7,1.1l-2.9,1.6 C264.7,327.2,264.3,327.3,263.8,327.3z M256.2,318c-0.3,0-0.5,0.1-0.7,0.1l-2.8,1.6c-0.1,0,0,0.1,0.2,0.2l10,5.7 c0.5,0.3,1.3,0.3,1.7,0.1l2.9-1.6c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.7C256.9,318.1,256.5,318,256.2,318z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1658_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_810_",
    className: "st0",
    d: "M418.5,237.7l-2.9,1.6c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l2.9-1.6c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C419,236.8,419,237.4,418.5,237.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_811_",
    className: "st1",
    d: "M414.6,240.2c-0.6,0-1.1-0.1-1.6-0.4l-10-5.8c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.8,0.7-1.1l2.9-1.6c0.8-0.4,2-0.4,2.9,0.1l10,5.8c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.8-0.7,1.1l-2.9,1.6 C415.6,240.1,415.1,240.2,414.6,240.2z M407.1,230.9c-0.3,0-0.5,0.1-0.7,0.1l-2.9,1.6c-0.1,0,0,0.1,0.2,0.2l10,5.8 c0.5,0.3,1.3,0.3,1.7,0.1l2.9-1.6c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.8C407.7,231,407.4,230.9,407.1,230.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1657_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_806_",
    className: "st0",
    d: "M127.7,361.1l-2.9,1.6c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l2.9-1.6c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C128.2,360.2,128.2,360.8,127.7,361.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_807_",
    className: "st1",
    d: "M123.8,363.6c-0.6,0-1.1-0.1-1.6-0.4l-10-5.7c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.8,0.7-1.1l2.9-1.6c0.8-0.4,2-0.4,2.9,0.1l10,5.8c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.8-0.7,1.1l-2.9,1.6 C124.8,363.5,124.3,363.6,123.8,363.6z M116.2,354.4c-0.3,0-0.5,0.1-0.7,0.1l-2.9,1.6c-0.1,0,0,0.1,0.2,0.2l10,5.8 c0.5,0.3,1.3,0.3,1.6,0.1l2.9-1.6c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.8C116.9,354.4,116.6,354.4,116.2,354.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1371_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_802_",
    className: "st0",
    d: "M196.1,365.6l-28.5,16.5c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l28.5-16.5c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C196.6,364.7,196.7,365.3,196.1,365.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_803_",
    className: "st1",
    d: "M166.6,382.9c-0.6,0-1.1-0.1-1.6-0.4l-10-5.7c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.8,0.7-1.1l28.5-16.5c0.8-0.4,2-0.4,2.9,0.1l10,5.8c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.9-0.7,1.1v0l-28.5,16.5 C167.5,382.8,167.1,382.9,166.6,382.9z M184.7,358.9c-0.3,0-0.5,0.1-0.7,0.1l-28.5,16.5c-0.1,0,0,0.1,0.2,0.2l10,5.7 c0.5,0.3,1.3,0.3,1.7,0.1l28.5-16.5c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.2-0.2l-10-5.8C185.4,359,185,358.9,184.7,358.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1344_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_798_",
    className: "st0",
    d: "M222.8,328.2l-48,27.7c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l48-27.7c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C223.3,327.3,223.4,327.9,222.8,328.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_799_",
    className: "st1",
    d: "M173.8,356.8c-0.6,0-1.1-0.1-1.6-0.4l-10-5.7c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.8,0.7-1.1l48-27.7c0.8-0.4,2-0.4,2.9,0.1l10,5.8c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.9-0.7,1.1v0l-48,27.7 C174.7,356.7,174.3,356.8,173.8,356.8z M211.4,321.4c-0.3,0-0.5,0.1-0.7,0.1l-48,27.7c-0.1,0,0,0.1,0.2,0.2l10,5.7 c0.5,0.3,1.3,0.3,1.7,0.1l48-27.7v0c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.8C212.1,321.5,211.7,321.4,211.4,321.4 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1343_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_794_",
    className: "st0",
    d: "M289,290l-21.5,12.4c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l21.5-12.4c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C289.5,289.1,289.6,289.6,289,290z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_795_",
    className: "st1",
    d: "M266.5,303.2c-0.6,0-1.1-0.1-1.6-0.4l-10-5.8c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.9,0.7-1.1l21.5-12.4c0.8-0.4,2-0.4,2.9,0.1l10,5.7c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.8-0.7,1.1l0,0 l-21.5,12.4C267.5,303.1,267,303.2,266.5,303.2z M277.6,283.2c-0.3,0-0.5,0.1-0.7,0.1l-21.5,12.4c-0.1,0,0,0.1,0.2,0.2 l10,5.8c0.5,0.3,1.3,0.3,1.7,0.1l21.5-12.4c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.7 C278.3,283.3,277.9,283.2,277.6,283.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1342_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_780_",
    className: "st0",
    d: "M409,220.7l-47.9,27.6c-0.6,0.3-1.6,0.3-2.3-0.1l-10-5.8c-0.7-0.4-0.7-1-0.2-1.3 l47.9-27.6c0.6-0.3,1.6-0.3,2.3,0.1l10,5.8C409.5,219.8,409.6,220.4,409,220.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_791_",
    className: "st1",
    d: "M360.2,249.2c-0.6,0-1.1-0.1-1.6-0.4l-10-5.8c-0.6-0.3-0.9-0.8-0.9-1.3 c0-0.4,0.3-0.9,0.7-1.1l47.9-27.6c0.8-0.5,2-0.4,2.9,0.1l10,5.8c0.6,0.3,0.9,0.8,0.9,1.3c0,0.4-0.3,0.8-0.7,1.1l-47.9,27.6 C361.1,249.1,360.6,249.2,360.2,249.2z M397.6,213.9c-0.3,0-0.5,0.1-0.7,0.1l-47.9,27.6c-0.1,0,0,0.1,0.2,0.2l10,5.8 c0.5,0.3,1.3,0.3,1.7,0.1l47.9-27.6c0.1,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.3-0.2l-10-5.8C398.3,214,398,213.9,397.6,213.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1320_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_790_",
    x: 308.2,
    y: 264.2,
    transform: "matrix(0.5001 -0.866 0.866 0.5001 -75.4902 400.1632)",
    className: "st1",
    width: 1.2,
    height: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_787_",
    className: "st1",
    d: "M322.2,273.9l-3.8-2.2l0.6-1.1l3.8,2.2L322.2,273.9z M315.9,270.2l-3.8-2.2l0.6-1.1 l3.8,2.2L315.9,270.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_10_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_786_",
    x: 325.4,
    y: 274.2,
    transform: "matrix(0.5001 -0.866 0.866 0.5001 -75.4916 420.0367)",
    className: "st1",
    width: 1.2,
    height: 2.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1312_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1314_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_12_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_785_",
    x: 239.7,
    y: 326.2,
    transform: "matrix(0.5001 -0.866 0.866 0.5001 -163.4078 371.8523)",
    className: "st1",
    width: 1.2,
    height: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_782_",
    className: "st1",
    d: "M253.7,335.9l-3.8-2.2l0.6-1.1l3.8,2.2L253.7,335.9z M247.4,332.2l-3.8-2.2l0.6-1.1 l3.8,2.2L247.4,332.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_781_",
    x: 256.9,
    y: 336.1,
    transform: "matrix(0.4998 -0.8662 0.8662 0.4998 -163.3906 391.8598)",
    className: "st1",
    width: 1.2,
    height: 2.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1313_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2319_",
    className: "st1",
    d: "M269,343.2l-1.3,0.8c-2.3,1.3-6.4,1.2-9-0.4l0,0c-2.7-1.5-3-3.9-0.6-5.2l1.3-0.8 c2.3-1.3,6.4-1.2,9,0.4h0C271,339.6,271.3,341.9,269,343.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1306_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1311_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_750_",
    className: "st0",
    d: "M142.4,326l-49.5,28.6c-2.5,1.5-7,1.3-9.9-0.4l-58.2-33.6c-2.9-1.7-3.3-4.3-0.7-5.7 l49.5-28.6c2.5-1.5,7-1.3,9.9,0.4l58.2,33.6C144.6,322,144.9,324.5,142.4,326z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_777_",
    className: "st1",
    d: "M88.6,356.2c-2,0-4.2-0.5-5.9-1.5l-58.3-33.6c-1.7-1-2.7-2.4-2.7-3.8c0-1.2,0.7-2.3,2-3 l49.5-28.6c2.8-1.6,7.4-1.4,10.6,0.4l58.2,33.6c1.7,1,2.7,2.4,2.7,3.8c0,1.2-0.7,2.3-2,3l-49.5,28.6 C92,355.8,90.3,356.2,88.6,356.2z M77.8,285.8c-1.5,0-2.9,0.3-4,0.9l-49.5,28.6c-0.6,0.4-1.4,1-1.4,2s0.8,1.9,2.1,2.7 l58.3,33.6c2.8,1.6,6.9,1.8,9.3,0.4l49.5-28.6c0.6-0.4,1.4-1,1.4-2c0-0.9-0.8-1.9-2.1-2.7l-58.2-33.6 C81.6,286.3,79.6,285.8,77.8,285.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1310_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_765_",
    className: "st1",
    d: "M86.8,346.3c-0.1-0.1-1.5-1.6-3.2-3.9l1-0.8c1.7,2.2,3.2,3.8,3.2,3.8L86.8,346.3z  M81.6,339.7c-1-1.5-1.9-2.9-2.6-4.3l1.1-0.6c0.7,1.3,1.6,2.7,2.6,4.2L81.6,339.7z M77.5,332.3c-0.7-1.8-1-3.4-1-4.9l0-0.2 l1.2,0l0,0.2c0,1.3,0.3,2.8,0.9,4.4L77.5,332.3z M78.5,324.4l-1.1-0.6c0.3-0.5,0.7-1,1.2-1.5c0.8-0.8,1.8-1.4,2.7-1.9 l0.6,1.1c-0.9,0.5-1.7,1.1-2.5,1.8C79.1,323.6,78.8,324,78.5,324.4z M94.1,320.5c-0.1,0-0.3,0-0.4-0.1 c-0.3-0.1-0.5-0.1-0.8-0.2l0.3-1.2c0.1,0,0.2,0,0.3,0.1c-0.4-0.4-0.9-0.8-1.3-1.2l0.9-0.9c0.8,0.8,1.5,1.4,2.1,1.9 c0.2,0.2,0.3,0.4,0.3,0.7C95.3,320.1,94.8,320.5,94.1,320.5z M85,320.3l-0.3-1.2c1.6-0.4,3.4-0.6,5.1-0.5l-0.1,1.2 C88.1,319.8,86.4,319.9,85,320.3z M89.7,315.5c-1.2-1.2-2.4-2.5-3.4-3.7l0.9-0.8c1,1.2,2.2,2.4,3.4,3.6L89.7,315.5z  M84.1,309.3c-1.1-1.4-2.1-2.8-2.9-4.1l1.1-0.6c0.8,1.3,1.7,2.6,2.8,4L84.1,309.3z M79.7,302.1c-0.8-1.8-1.3-3.4-1.4-4.9 l1.2-0.1c0.1,1.4,0.6,2.9,1.3,4.6L79.7,302.1z M79.7,294l-1.2-0.3c0.5-1.7,1.5-3.1,3-4.3l0.8,1C81,291.4,80.1,292.6,79.7,294 z M85,288.7l-0.5-1.1c0.2-0.1,0.5-0.2,0.7-0.3l0.5,1.2C85.5,288.5,85.2,288.6,85,288.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1309_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_751_",
    className: "st1",
    d: "M97.5,340.3c0,0-1.6-1.1-4.1-2.9l0.7-1c2.4,1.8,4,2.9,4,2.9L97.5,340.3z M90.8,335.3 c-1.2-1-2.5-2-3.9-3.1l0.8-1c1.3,1.1,2.7,2.2,3.9,3.1L90.8,335.3z M84.3,330c-1.3-1.2-2.6-2.3-3.7-3.4l0.9-0.9 c1.1,1.1,2.3,2.2,3.7,3.3L84.3,330z M78.3,324.2c-1.3-1.3-2.4-2.6-3.3-3.8l1-0.8c0.9,1.2,2,2.4,3.2,3.7L78.3,324.2z  M73,317.7c-1.1-1.7-1.8-3.3-2.1-4.7l1.2-0.3c0.3,1.3,0.9,2.7,1.9,4.3L73,317.7z M105.8,315.9c-0.2,0-0.5,0-0.7-0.1l-1.6-0.6 l0.4-1.2l1.6,0.6c0.5,0.2,1-0.2,1-0.7c0-0.1,0-0.2-0.1-0.3l1.1-0.5c0.1,0.3,0.2,0.5,0.2,0.8 C107.8,315,106.9,315.9,105.8,315.9z M100.4,314.1c-1.5-0.5-3.1-1-4.7-1.6l0.4-1.2c1.7,0.5,3.3,1.1,4.7,1.6L100.4,314.1z  M92.5,311.5c-1.6-0.5-3.2-0.9-4.8-1.3l0.3-1.2c1.6,0.4,3.2,0.8,4.8,1.3L92.5,311.5z M107.2,310.2l-1.2-0.3 c0.4-1.6,1.6-2.9,3.6-3.9l0.5,1.1C108.5,307.9,107.5,309,107.2,310.2z M72.4,310l-1-0.8c0.9-1.1,2.6-1.8,5-1.9l0.1,1.2 C74.4,308.7,73,309.2,72.4,310z M84.5,309.5c-1.8-0.4-3.4-0.6-4.8-0.8l0.1-1.2c1.5,0.1,3.1,0.4,5,0.8L84.5,309.5z  M113.2,306.1l-0.3-1.2c0.7-0.2,1.4-0.3,2.2-0.5l0.2,1.2C114.6,305.8,113.9,305.9,113.2,306.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1308_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2284_",
    className: "st1",
    d: "M90.7,350.1l-0.3,0.2c-1.1,0.6-2.9,0.5-4.1-0.2l-55.7-32.2c-1.2-0.7-1.4-1.8-0.3-2.4 l0.3-0.2c1.1-0.6,2.9-0.5,4.1,0.2l55.7,32.2C91.6,348.4,91.7,349.4,90.7,350.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1307_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_746_",
    className: "st0",
    d: "M136.1,323.5l-45.6,26.3c-0.8,0.5-2.2,0.4-3.1-0.1l0,0c-0.9-0.5-1-1.3-0.2-1.8 l45.6-26.3c0.8-0.5,2.2-0.4,3.1,0.1l0,0C136.8,322.2,136.9,323,136.1,323.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_747_",
    className: "st1",
    d: "M89.2,350.7c-0.7,0-1.5-0.2-2.1-0.5c-0.7-0.4-1.1-1-1.1-1.6c0-0.5,0.3-1,0.8-1.3 l45.6-26.3c1-0.6,2.6-0.5,3.7,0.1c0.7,0.4,1.1,1,1.1,1.6c0,0.5-0.3,1-0.8,1.3l-45.6,26.3C90.4,350.6,89.8,350.7,89.2,350.7z  M134.1,321.8c-0.4,0-0.8,0.1-1,0.2l-45.6,26.3c-0.1,0.1-0.2,0.2-0.2,0.2c0,0.1,0.1,0.3,0.5,0.5c0.7,0.4,1.9,0.5,2.5,0.1 l45.6-26.3c0.1-0.1,0.2-0.2,0.2-0.2c0-0.1-0.1-0.3-0.5-0.5C135.1,322,134.6,321.8,134.1,321.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1287_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1305_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_742_",
    className: "st0",
    d: "M411.2,170.8l-37.4,21.6c-2.5,1.5-7,1.3-9.9-0.4l-58.2-33.6c-2.9-1.7-3.3-4.3-0.7-5.7 l37.4-21.6c2.5-1.5,7-1.3,9.9,0.4l58.2,33.6C413.4,166.8,413.7,169.4,411.2,170.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_743_",
    className: "st1",
    d: "M369.4,194.1c-2.1,0-4.2-0.5-5.9-1.5l-58.3-33.6c-1.7-1-2.7-2.4-2.7-3.8 c0-1.2,0.7-2.3,2-3l37.4-21.6c2.8-1.6,7.4-1.4,10.6,0.4l58.2,33.6c1.7,1,2.7,2.4,2.7,3.8c0,1.2-0.7,2.3-2,3L374,193 C372.8,193.7,371.1,194.1,369.4,194.1z M346.6,130.7c-1.5,0-2.9,0.3-4,0.9l-37.4,21.6c-0.6,0.4-1.4,1-1.4,2 c0,0.9,0.8,1.9,2.1,2.7l58.3,33.6c2.8,1.6,6.9,1.8,9.3,0.4l37.4-21.6c0.6-0.4,1.4-1,1.4-2c0-0.9-0.8-1.9-2.1-2.7L351.9,132 C350.4,131.1,348.4,130.7,346.6,130.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1302_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1304_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_738_",
    className: "st1",
    d: "M355.7,141l-9.3,5.4c-0.8,0.5-2.2,0.4-3.1-0.1l0,0c-0.9-0.5-1-1.3-0.2-1.8l9.3-5.4 c0.8-0.5,2.2-0.4,3.1,0.1l0,0C356.4,139.8,356.5,140.6,355.7,141z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_739_",
    className: "st1",
    d: "M345,147.3c-0.7,0-1.5-0.2-2.1-0.5c-0.7-0.4-1.1-1-1.1-1.6c0-0.5,0.3-1,0.8-1.3 l9.3-5.4c1-0.6,2.6-0.5,3.7,0.1c0.7,0.4,1.1,1,1.1,1.6c0,0.5-0.3,1-0.8,1.3l-9.3,5.4C346.2,147.2,345.6,147.3,345,147.3z  M353.7,139.4c-0.4,0-0.8,0.1-1,0.2l-9.3,5.4c-0.1,0.1-0.2,0.2-0.2,0.2c0,0.1,0.1,0.3,0.5,0.5c0.7,0.4,1.9,0.5,2.5,0.1 l9.3-5.4c0.1-0.1,0.2-0.2,0.2-0.2c0-0.1-0.1-0.3-0.5-0.5C354.7,139.5,354.2,139.4,353.7,139.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1303_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_734_",
    className: "st0",
    d: "M362.1,144.8l-9.3,5.4c-0.8,0.5-2.2,0.4-3.1-0.1l0,0c-0.9-0.5-1-1.3-0.2-1.8l9.3-5.4 c0.8-0.5,2.2-0.4,3.1,0.1l0,0C362.8,143.5,362.9,144.3,362.1,144.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_735_",
    className: "st1",
    d: "M351.5,151.1c-0.7,0-1.5-0.2-2.1-0.5c-0.7-0.4-1.1-1-1.1-1.6c0-0.5,0.3-1,0.8-1.3 l9.3-5.4c1-0.6,2.6-0.5,3.7,0.1c0.7,0.4,1.1,1,1.1,1.6c0,0.5-0.3,1-0.9,1.3l-9.3,5.4C352.7,150.9,352.1,151.1,351.5,151.1z  M360.1,143.1c-0.4,0-0.8,0.1-1,0.2l-9.3,5.4c-0.1,0.1-0.2,0.2-0.2,0.2c0,0.1,0.1,0.3,0.5,0.5c0.7,0.4,1.9,0.5,2.5,0.1 l9.3-5.4c0.1-0.1,0.2-0.2,0.2-0.2c0-0.1-0.1-0.3-0.5-0.5C361.2,143.3,360.6,143.1,360.1,143.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1298_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1301_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_730_",
    className: "st1",
    d: "M355.3,157.8l-18.8,10.9c-0.8,0.5-2.2,0.4-3.1-0.1l0,0c-0.9-0.5-1-1.3-0.2-1.8 l18.8-10.9c0.8-0.5,2.2-0.4,3.1,0.1l0,0C356,156.6,356.1,157.4,355.3,157.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_731_",
    className: "st1",
    d: "M335.1,169.6c-0.7,0-1.5-0.2-2.1-0.5c-0.7-0.4-1.1-1-1.1-1.6c0-0.5,0.3-1,0.8-1.3 l18.8-10.9c1-0.6,2.6-0.5,3.7,0.1c0.7,0.4,1.1,1,1.1,1.6c0,0.5-0.3,1-0.9,1.3l-18.8,10.9 C336.3,169.5,335.7,169.6,335.1,169.6z M353.3,156.2c-0.4,0-0.8,0.1-1,0.2l-18.8,10.9c-0.1,0.1-0.2,0.2-0.2,0.2 c0,0.1,0.1,0.3,0.5,0.5c0.7,0.4,1.9,0.5,2.5,0.1l18.8-10.9c0.1-0.1,0.2-0.2,0.2-0.2c0-0.1-0.1-0.3-0.5-0.5 C354.4,156.3,353.8,156.2,353.3,156.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1300_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_726_",
    className: "st0",
    d: "M361.8,161.6l-18.8,10.9c-0.8,0.5-2.2,0.4-3.1-0.1l0,0c-0.9-0.5-1-1.3-0.2-1.8 l18.8-10.9c0.8-0.5,2.2-0.4,3.1,0.1l0,0C362.5,160.3,362.6,161.1,361.8,161.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_727_",
    className: "st1",
    d: "M341.6,173.3c-0.7,0-1.5-0.2-2.1-0.5c-0.7-0.4-1.1-1-1.1-1.6c0-0.5,0.3-1,0.9-1.3 l18.8-10.9c1-0.6,2.6-0.5,3.7,0.1c0.7,0.4,1.1,1,1.1,1.6c0,0.5-0.3,1-0.8,1.3L343.3,173 C342.8,173.2,342.2,173.3,341.6,173.3z M359.8,159.9c-0.4,0-0.8,0.1-1,0.2L339.9,171c-0.1,0.1-0.2,0.2-0.2,0.2 c0,0.1,0.1,0.3,0.5,0.5c0.7,0.4,1.9,0.5,2.5,0.1l18.8-10.9c0.1-0.1,0.2-0.2,0.2-0.2c0-0.1-0.1-0.3-0.5-0.5 C360.8,160.1,360.3,159.9,359.8,159.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1299_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_722_",
    className: "st0",
    d: "M368.2,165.3l-18.8,10.9c-0.8,0.5-2.2,0.4-3.1-0.1l0,0c-0.9-0.5-1-1.3-0.2-1.8 l18.8-10.9c0.8-0.5,2.2-0.4,3.1,0.1l0,0C368.9,164,369,164.8,368.2,165.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_723_",
    className: "st1",
    d: "M348.1,177.1c-0.7,0-1.5-0.2-2.1-0.5c-0.7-0.4-1.1-1-1.1-1.6c0-0.5,0.3-1,0.9-1.3 l18.8-10.9c1-0.6,2.6-0.5,3.7,0.1c0.7,0.4,1.1,1,1.1,1.6c0,0.5-0.3,1-0.8,1.3l-18.8,10.9 C349.3,176.9,348.7,177.1,348.1,177.1z M366.2,163.7c-0.4,0-0.8,0.1-1,0.2l-18.8,10.9c-0.1,0.1-0.2,0.2-0.2,0.2 c0,0.1,0.1,0.3,0.5,0.5c0.7,0.4,1.9,0.5,2.5,0.1l18.8-10.9c0.1-0.1,0.2-0.2,0.2-0.2c0-0.1-0.1-0.3-0.5-0.5 C367.3,163.8,366.7,163.7,366.2,163.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1295_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1297_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_718_",
    className: "st1",
    d: "M390.8,161.2l-9.5,5.5c-0.7,0.4-2.1,0.4-2.9-0.1l-0.2-0.1c-0.9-0.5-1-1.3-0.2-1.7 l9.5-5.5c0.7-0.4,2.1-0.4,2.9,0.1l0.2,0.1C391.5,160,391.6,160.8,390.8,161.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_719_",
    className: "st1",
    d: "M380.1,167.6c-0.7,0-1.4-0.2-2-0.5l-0.2-0.1c-0.7-0.4-1-0.9-1-1.5c0-0.5,0.3-1,0.8-1.3 l9.5-5.5c0.9-0.5,2.5-0.5,3.5,0.1l0.2,0.1c0.7,0.4,1,0.9,1,1.5c0,0.5-0.3,1-0.8,1.3l-9.5,5.5 C381.2,167.5,380.7,167.6,380.1,167.6z M388.8,159.6c-0.4,0-0.7,0.1-1,0.2l-9.5,5.5c-0.1,0.1-0.2,0.2-0.2,0.2 c0,0.1,0.1,0.2,0.4,0.4l0.2,0.1c0.7,0.4,1.7,0.4,2.3,0.1l9.5-5.5c0.1-0.1,0.2-0.2,0.2-0.2c0-0.1-0.1-0.2-0.4-0.4l-0.2-0.1 C389.7,159.7,389.2,159.6,388.8,159.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1296_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_714_",
    className: "st0",
    d: "M397.3,165l-9.5,5.5c-0.7,0.4-2.1,0.4-2.9-0.1l-0.2-0.1c-0.9-0.5-1-1.3-0.2-1.7 l9.5-5.5c0.7-0.4,2.1-0.4,2.9,0.1l0.2,0.1C398,163.8,398,164.5,397.3,165z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_715_",
    className: "st1",
    d: "M386.5,171.3c-0.7,0-1.4-0.2-2-0.5l-0.2-0.1c-0.7-0.4-1-0.9-1-1.5c0-0.5,0.3-1,0.8-1.3 l9.5-5.5c0.9-0.5,2.5-0.5,3.5,0.1l0.2,0.1c0.7,0.4,1,0.9,1,1.5c0,0.5-0.3,1-0.8,1.3l-9.5,5.5 C387.7,171.2,387.1,171.3,386.5,171.3z M395.2,163.4c-0.4,0-0.7,0.1-1,0.2l-9.5,5.5c-0.1,0.1-0.2,0.2-0.2,0.2 c0,0.1,0.1,0.2,0.4,0.4l0.2,0.1c0.7,0.4,1.7,0.4,2.3,0.1l9.5-5.5c0.1-0.1,0.2-0.2,0.2-0.2c0-0.1-0.1-0.2-0.4-0.4l-0.2-0.1 C396.2,163.5,395.7,163.4,395.2,163.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1294_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_709_",
    className: "st0",
    d: "M341,156.9l-8.6,4.9c-2.3,1.4-6.4,1.2-9.1-0.4l0,0c-2.7-1.6-3-3.9-0.7-5.3l8.6-4.9 c2.3-1.4,6.4-1.2,9.1,0.4l0,0C343.1,153.2,343.4,155.6,341,156.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_710_",
    className: "st1",
    d: "M328.5,163.4c-1.9,0-3.9-0.5-5.5-1.4c-1.6-0.9-2.5-2.2-2.5-3.5c0-1.1,0.7-2.1,1.9-2.8 l8.6-4.9c2.6-1.5,6.8-1.3,9.8,0.4c1.6,0.9,2.6,2.2,2.6,3.5c0,1.1-0.7,2.1-1.9,2.8l-8.6,4.9 C331.6,163.1,330.1,163.4,328.5,163.4z M335.2,151c-1.4,0-2.7,0.3-3.7,0.8l-8.6,4.9c-0.6,0.3-1.3,0.9-1.3,1.8 c0,0.8,0.7,1.7,1.9,2.4c2.5,1.5,6.4,1.6,8.5,0.4l8.6-4.9c0.6-0.3,1.3-0.9,1.3-1.8c0-0.8-0.7-1.7-1.9-2.4 C338.7,151.4,336.9,151,335.2,151z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1293_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_703_",
    className: "st1",
    d: "M375.5,177.6l-8.6,4.9c-2.3,1.4-6.4,1.2-9.1-0.4l0,0c-2.7-1.6-3-3.9-0.7-5.3l8.6-4.9 c2.3-1.4,6.4-1.2,9.1,0.4h0C377.5,173.8,377.8,176.2,375.5,177.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_705_",
    className: "st1",
    d: "M362.9,184.1c-1.9,0-3.9-0.5-5.5-1.4c-1.6-0.9-2.6-2.2-2.6-3.5c0-1.1,0.7-2.1,1.9-2.8 l8.6-4.9c2.6-1.5,6.8-1.3,9.8,0.4c1.6,0.9,2.6,2.2,2.6,3.5c0,1.1-0.7,2.1-1.9,2.8l-8.6,4.9 C366.1,183.7,364.5,184.1,362.9,184.1z M369.6,171.6c-1.4,0-2.7,0.3-3.7,0.8l-8.6,4.9c-0.6,0.3-1.3,0.9-1.3,1.8 c0,0.8,0.7,1.7,1.9,2.5c2.5,1.5,6.4,1.6,8.5,0.4l8.6-4.9c0.6-0.3,1.3-0.9,1.3-1.8c0-0.8-0.7-1.7-1.9-2.5 C373.1,172,371.3,171.6,369.6,171.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1292_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_692_",
    className: "st1",
    d: "M380.3,158.3l-0.6,0.4c-2.3,1.3-6.2,1.1-8.8-0.4l-6.8-4c-2.6-1.5-2.9-3.8-0.6-5.1 l0.6-0.4c2.3-1.3,6.2-1.1,8.8,0.4l6.8,4C382.3,154.7,382.6,157,380.3,158.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_700_",
    className: "st1",
    d: "M375.9,160.2c-1.8,0-3.7-0.5-5.3-1.3l-6.8-4c-1.6-0.9-2.5-2.1-2.5-3.4 c0-1.1,0.6-2.1,1.8-2.7l0.6-0.4c2.5-1.4,6.6-1.3,9.4,0.4l6.8,4c1.6,0.9,2.5,2.1,2.5,3.4c0,1.1-0.7,2.1-1.8,2.7l-0.6,0.4 C378.9,159.8,377.4,160.2,375.9,160.2z M367.9,148.6c-1.3,0-2.6,0.3-3.5,0.8l-0.6,0.4c-0.6,0.3-1.2,0.9-1.2,1.7 c0,0.8,0.7,1.7,1.8,2.3l6.8,4c2.4,1.4,6.1,1.6,8.2,0.4l0.6-0.4c0.6-0.3,1.2-0.9,1.2-1.7c0-0.8-0.7-1.7-1.8-2.3l-6.8-4 C371.2,149,369.5,148.6,367.9,148.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1267_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_693_",
    className: "st1",
    d: "M434.8,206.5l-0.6-1.1l4.3-2.5l0.6,1.1L434.8,206.5z M442,202.4l-0.6-1.1l4.3-2.5 l0.6,1.1L442,202.4z M449.2,198.2l-0.6-1.1l4.3-2.5l0.6,1.1L449.2,198.2z M456.3,194.1l-0.6-1.1l4.3-2.5l0.6,1.1L456.3,194.1z  M463.5,190l-0.6-1.1l4.3-2.5l0.6,1.1L463.5,190z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_522_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_11_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_690_",
    className: "st0",
    d: "M304.7,232.3l-145.6,84.1c-2.5,1.5-7,1.3-9.9-0.4l-58.2-33.6c-2.9-1.7-3.3-4.3-0.7-5.7 l197.9-114.3c2.5-1.5,7-1.3,9.9,0.4l58.2,33.6c2.9,1.7,3.3,4.3,0.7,5.7l-39,22.5L304.7,232.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_691_",
    className: "st1",
    d: "M154.8,318c-2.1,0-4.2-0.5-5.9-1.5l-58.3-33.6c-1.7-1-2.7-2.4-2.7-3.8 c0-1.2,0.7-2.3,2-3l197.9-114.3c2.8-1.6,7.4-1.4,10.6,0.4l58.3,33.6c1.7,1,2.7,2.4,2.7,3.8c0,1.2-0.7,2.3-2,3l-39,22.5 l-0.6-1.1l39-22.5c0.6-0.4,1.4-1,1.4-2c0-0.9-0.8-1.9-2.1-2.7l-58.3-33.6c-2.8-1.6-6.9-1.8-9.3-0.4L90.5,277.1 c-0.6,0.4-1.4,1-1.4,2c0,0.9,0.8,1.9,2.1,2.7l58.3,33.6c2.8,1.6,6.9,1.8,9.3,0.4l145.6-84.1l0.6,1.1l-145.6,84.1 C158.1,317.6,156.5,318,154.8,318z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_523_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_526_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_686_",
    className: "st0",
    cx: 223.7,
    cy: 239.4,
    rx: 30.6,
    ry: 17.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_687_",
    className: "st1",
    d: "M223.7,257.6c-7.9,0-15.9-1.7-21.9-5.2c-6-3.5-9.3-8.1-9.3-13c0-4.9,3.3-9.6,9.3-13 c12.1-7,31.8-7,43.9,0l0,0c6,3.5,9.3,8.1,9.3,13c0,5-3.3,9.6-9.3,13C239.5,255.9,231.6,257.6,223.7,257.6z M223.7,222.3 c-7.7,0-15.4,1.7-21.3,5.1c-5.6,3.2-8.7,7.5-8.7,12c0,4.5,3.1,8.7,8.7,12c11.8,6.8,30.9,6.8,42.7,0c5.6-3.2,8.7-7.5,8.7-12 c0-4.5-3.1-8.7-8.7-12C239.1,224,231.4,222.3,223.7,222.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_527_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_598_",
    className: "st1",
    d: "M212,239.6l12.2,7c1.6,0.9,4.4,0.5,5-0.8l4.5-9.6c0.6-1.3-1.4-2.5-3.7-2.1l-16.7,2.6 C211.2,237.1,210.4,238.7,212,239.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_683_",
    className: "st1",
    d: "M226.3,247.7c-0.9,0-1.7-0.2-2.4-0.6l-12.2-7c-0.9-0.5-1.3-1.3-1.2-2.1 c0.2-1,1.2-1.8,2.7-2l16.7-2.6c1.7-0.3,3.4,0.2,4.1,1.2c0.4,0.5,0.5,1.2,0.2,1.8l-4.5,9.6c-0.3,0.6-0.9,1.1-1.8,1.4 C227.4,247.7,226.9,247.7,226.3,247.7z M212.4,239.1l12.2,7c0.8,0.5,2,0.6,3.1,0.2c0.5-0.2,0.9-0.4,1.1-0.7l4.5-9.6 c0.1-0.1,0.1-0.3-0.1-0.5c-0.4-0.5-1.6-1-2.9-0.7l-16.7,2.6c-1.1,0.2-1.6,0.6-1.7,1C211.7,238.7,212.2,239,212.4,239.1 L212.4,239.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_986_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_604_",
    className: "st1",
    d: "M155.6,311.7c-0.8,0-1.6-0.2-2.2-0.5l-1.4-0.8l0.6-1.1l1.4,0.8c0.7,0.4,1.9,0.5,2.8,0.2 l0.4,1.2C156.7,311.6,156.2,311.7,155.6,311.7z M160.2,309.8l-0.6-1.1l4.3-2.5l0.6,1.1L160.2,309.8z M149.1,308.7l-4.3-2.5 l0.6-1.1l4.3,2.5L149.1,308.7z M167.4,305.6l-0.6-1.1l4.3-2.5l0.6,1.1L167.4,305.6z M142,304.6l-4.3-2.5l0.6-1.1l4.3,2.5 L142,304.6z M174.5,301.5l-0.6-1.1l4.3-2.5l0.6,1.1L174.5,301.5z M134.8,300.4l-4.3-2.5l0.6-1.1l4.3,2.5L134.8,300.4z  M181.7,297.4l-0.6-1.1l4.3-2.5l0.6,1.1L181.7,297.4z M127.6,296.3l-4.3-2.5l0.6-1.1l4.3,2.5L127.6,296.3z M188.9,293.2 l-0.6-1.1l4.3-2.5l0.6,1.1L188.9,293.2z M120.4,292.1l-4.3-2.5l0.6-1.1l4.3,2.5L120.4,292.1z M196.1,289.1l-0.6-1.1l4.3-2.5 l0.6,1.1L196.1,289.1z M113.3,288l-4.3-2.5l0.6-1.1l4.3,2.5L113.3,288z M203.2,284.9l-0.6-1.1l4.3-2.5l0.6,1.1L203.2,284.9z  M106.1,283.9l-4.3-2.5l0.6-1.1l4.3,2.5L106.1,283.9z M210.4,280.8l-0.6-1.1l4.3-2.5l0.6,1.1L210.4,280.8z M98.8,279.5 c-0.2-0.3-0.4-0.7-0.4-1c0-0.6,0.4-1.2,1.1-1.6l2.5-1.4l0.6,1.1l-2.5,1.4c-0.3,0.2-0.5,0.4-0.5,0.5c0,0.1,0,0.2,0.1,0.3 L98.8,279.5z M217.6,276.6l-0.6-1.1l4.3-2.5l0.6,1.1L217.6,276.6z M105.5,274.8l-0.6-1.1l4.3-2.5l0.6,1.1L105.5,274.8z  M224.8,272.5l-0.6-1.1l4.3-2.5l0.6,1.1L224.8,272.5z M112.7,270.7l-0.6-1.1l4.3-2.5l0.6,1.1L112.7,270.7z M232,268.4 l-0.6-1.1l4.3-2.5l0.6,1.1L232,268.4z M119.8,266.5l-0.6-1.1l4.3-2.5l0.6,1.1L119.8,266.5z M239.1,264.2l-0.6-1.1l4.3-2.5 l0.6,1.1L239.1,264.2z M127,262.4l-0.6-1.1l4.3-2.5l0.6,1.1L127,262.4z M246.3,260.1l-0.6-1.1l4.3-2.5l0.6,1.1L246.3,260.1z  M134.2,258.2l-0.6-1.1l4.3-2.5l0.6,1.1L134.2,258.2z M253.5,255.9l-0.6-1.1l4.3-2.5l0.6,1.1L253.5,255.9z M141.4,254.1 l-0.6-1.1l4.3-2.5l0.6,1.1L141.4,254.1z M260.7,251.8l-0.6-1.1l4.3-2.5l0.6,1.1L260.7,251.8z M148.5,249.9l-0.6-1.1l4.3-2.5 l0.6,1.1L148.5,249.9z M267.8,247.6l-0.6-1.1l4.3-2.5l0.6,1.1L267.8,247.6z M155.7,245.8l-0.6-1.1l4.3-2.5l0.6,1.1 L155.7,245.8z M275,243.5l-0.6-1.1l4.3-2.5l0.6,1.1L275,243.5z M162.9,241.7l-0.6-1.1l4.3-2.5l0.6,1.1L162.9,241.7z  M282.2,239.3l-0.6-1.1l4.3-2.5l0.6,1.1L282.2,239.3z M170.1,237.5l-0.6-1.1l4.3-2.5l0.6,1.1L170.1,237.5z M289.4,235.2 l-0.6-1.1l4.3-2.5l0.6,1.1L289.4,235.2z M177.3,233.4l-0.6-1.1l4.3-2.5l0.6,1.1L177.3,233.4z M296.5,231.1l-0.6-1.1l4.3-2.5 l0.6,1.1L296.5,231.1z M184.4,229.2l-0.6-1.1l4.3-2.5l0.6,1.1L184.4,229.2z M303.7,226.9l-0.6-1.1l4.3-2.5l0.6,1.1 L303.7,226.9z M191.6,225.1L191,224l4.3-2.5l0.6,1.1L191.6,225.1z M310.9,222.8l-0.6-1.1l4.3-2.5l0.6,1.1L310.9,222.8z  M198.8,220.9l-0.6-1.1l4.3-2.5l0.6,1.1L198.8,220.9z M318.1,218.6l-0.6-1.1l4.3-2.5l0.6,1.1L318.1,218.6z M206,216.8 l-0.6-1.1l4.3-2.5l0.6,1.1L206,216.8z M325.3,214.5l-0.6-1.1l4.3-2.5l0.6,1.1L325.3,214.5z M213.1,212.6l-0.6-1.1l4.3-2.5 l0.6,1.1L213.1,212.6z M332.4,210.3l-0.6-1.1l4.3-2.5l0.6,1.1L332.4,210.3z M220.3,208.5l-0.6-1.1l4.3-2.5l0.6,1.1 L220.3,208.5z M339.6,206.2l-0.6-1.1l4.3-2.5l0.6,1.1L339.6,206.2z M227.5,204.4l-0.6-1.1l4.3-2.5l0.6,1.1L227.5,204.4z  M346.8,202.1l-0.6-1.1l0.2-0.1c0.3-0.2,0.5-0.4,0.5-0.5s-0.2-0.4-0.5-0.5l-4.3-2.5l0.6-1.1l4.3,2.5c0.7,0.4,1.1,1,1.1,1.6 c0,0.6-0.4,1.2-1.1,1.6L346.8,202.1z M234.7,200.2l-0.6-1.1l4.3-2.5l0.6,1.1L234.7,200.2z M241.8,196.1l-0.6-1.1l4.3-2.5 l0.6,1.1L241.8,196.1z M339.2,195.6l-4.3-2.5l0.6-1.1l4.3,2.5L339.2,195.6z M249,191.9l-0.6-1.1l4.3-2.5l0.6,1.1L249,191.9z  M332,191.5l-4.3-2.5l0.6-1.1l4.3,2.5L332,191.5z M256.2,187.8l-0.6-1.1l4.3-2.5l0.6,1.1L256.2,187.8z M324.9,187.3l-4.3-2.5 l0.6-1.1l4.3,2.5L324.9,187.3z M263.4,183.6l-0.6-1.1l4.3-2.5l0.6,1.1L263.4,183.6z M317.7,183.2l-4.3-2.5l0.6-1.1l4.3,2.5 L317.7,183.2z M270.6,179.5l-0.6-1.1l4.3-2.5l0.6,1.1L270.6,179.5z M310.5,179l-4.3-2.5l0.6-1.1l4.3,2.5L310.5,179z  M277.7,175.4l-0.6-1.1l4.3-2.5l0.6,1.1L277.7,175.4z M303.3,174.9l-4.3-2.5l0.6-1.1l4.3,2.5L303.3,174.9z M284.9,171.2 l-0.6-1.1l4.3-2.5l0.6,1.1L284.9,171.2z M296.1,170.8l-3.6-2.1c-0.2-0.1-0.3-0.2-0.6-0.2l0.3-1.2c0.3,0.1,0.6,0.2,0.8,0.3 l3.6,2.1L296.1,170.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1315_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_600_",
    className: "st1",
    d: "M425.3,233.3l-0.6-1.1l4.3-2.5l0.6,1.1L425.3,233.3z M432.5,229.1l-0.6-1.1l4.3-2.5 l0.6,1.1L432.5,229.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1741_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1316_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1217_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1218_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_593_",
    className: "st1",
    d: "M261.2,221c0-2.8,1.9-5.4,4.8-6.1c2-0.5,4.7-0.5,8.2,0.6c4,1.4,10.1,3.6,15.5,5.6 c7.5,2.7,14.8,6,21.8,9.6l0,0c0.2,0.1,0.4-0.1,0.4-0.3c-0.3-1.4-0.6-4.9,4-9.3c5.9-5.6,15-2.2,23.6-2.4c0,0-0.9-4.4,0.7-7.5 c1.6-3.1,8.7-7.4,16.1-4.8c7.5,2.6,16.5,3.8,16.5,3.8s4.3-4.2,10.8-2.6s17.7,2.9,17.7,2.9s13.3,2.3,26.9,9.1 c5.4,2.7,10.7,5.7,15.1,8.3c6.5,3.8,13.6,6.6,21.1,8.2c2.9,0.6,6.2,1.5,9.7,2.8c10.4,3.9,198.9,82.5,198.9,82.5 s-8.9,168.8-8.8,169.5s-109.9-95-109.9-95s-81.9-63.3-109-78.6l-8.2-3c-5.6-2.1-11.8-1.1-16.7,2.4c-3.5,2.5-8.1,5-13.5,6 c-11.9,2.1-20.7,4.9-31.4,8.5c-10.7,3.6-24.1,1.8-35.9,1.2c-11.8-0.6-26.6,2.6-39.3,0.5c-12.7-2.1-14.3-6.5-14.7-12.9 c-0.4-6.4,7.5-10.3,15.2-11.9c7.7-1.5,35.5-2.3,43.9-4c8.4-1.6,6.2-7.5,4.8-10.2c-1.4-2.7-8.7-9.6-13.3-15.5 c-4.6-5.9-20.7-18.1-32.1-25.2c-11.4-7.1-33.2-20.5-39.1-24.5C261.9,226.6,261.2,223.5,261.2,221z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1177_",
    className: "st0",
    d: "M266.1,229.6c0-2.8,1.9-5.4,4.8-6.1c2-0.5,4.7-0.5,8.2,0.6c4,1.4,10.1,3.6,15.5,5.6 c7.5,2.7,14.8,6,21.8,9.6h0c0.2,0.1,0.4-0.1,0.4-0.3c-0.3-1.4-0.6-4.9,4-9.3c5.9-5.6,15-2.2,23.6-2.4c0,0-0.9-4.4,0.7-7.5 c1.6-3.1,8.7-7.4,16.1-4.8c7.5,2.6,16.5,3.8,16.5,3.8s4.3-4.2,10.8-2.6c6.6,1.5,17.7,2.9,17.7,2.9s13.3,2.3,26.9,9.1 c5.4,2.7,10.7,5.7,15.1,8.3c6.5,3.8,13.6,6.6,21.1,8.2c2.9,0.6,6.2,1.5,9.7,2.8C489.5,251.4,678,330,678,330 s-8.9,168.8-8.8,169.5c0.1,0.7-111.8-92.7-111.8-92.7s-72.2-53.5-95.7-69.7c-3-2-8.3-5.5-11.6-7l-2.8-1.5 c-2.8-1.5-5.8-2.6-9-3.2c-4.2-0.8-8.5-0.8-12,0.9c-3.8,1.9-9.1,3.9-14.5,4.8c-11.9,2.1-20.7,4.9-31.4,8.5 c-10.7,3.6-24.1,1.8-35.9,1.2s-26.6,2.6-39.3,0.5s-14.3-6.5-14.7-12.9c-0.4-6.4,7.5-10.3,15.2-11.9s35.5-2.3,43.9-4 c8.4-1.6,6.2-7.5,4.8-10.2c-1.4-2.7-8.7-9.6-13.3-15.5c-4.6-5.9-20.7-18.1-32.1-25.2c-11.4-7.1-33.2-20.5-39.1-24.5 C266.8,235.2,266.1,232.1,266.1,229.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_594_",
    className: "st1",
    d: "M664.4,492c-0.8,0-3-1.9-18.2-15c-10.3-8.9-24.1-20.8-37.8-32.7 c-27.4-23.8-54.8-47.6-54.8-47.6c-0.8-0.6-81.9-63.3-108.8-78.4l-8.1-3c-5.2-1.9-11.1-1.1-15.7,2.3 c-4.5,3.3-9.2,5.3-13.9,6.2c-11.5,2-19.8,4.7-31.2,8.5c-9,3-19.7,2.3-30,1.6c-2.1-0.1-4.2-0.3-6.3-0.4 c-4.7-0.2-9.9,0.1-15.4,0.5c-8,0.6-16.4,1.2-24-0.1c-12.6-2.1-15.2-6.3-15.6-13.9c-0.4-7.2,8-11.4,16-13 c3.9-0.8,12.4-1.3,21.5-1.9c9-0.6,18.2-1.2,22.4-2c2.6-0.5,4.2-1.4,4.9-2.8c0.7-1.4,0.4-3.4-0.9-5.9c-0.7-1.3-3.2-4.1-5.9-7 c-2.4-2.6-5.1-5.6-7.3-8.3c-4.5-5.7-20.5-17.8-31.8-24.9c-3.4-2.1-7.8-4.9-12.4-7.7c-10.6-6.5-22.6-14-26.7-16.8 c-3.6-2.4-4.3-6.1-4.3-8.7c0-3.4,2.3-6.3,5.6-7.1c2.7-0.6,5.6-0.4,8.8,0.7c4.2,1.4,10.8,3.8,15.6,5.6c7,2.6,13.9,5.6,20.5,9 c0-2,0.8-5.1,4.5-8.7c4.5-4.3,10.9-3.7,17-3.1c2,0.2,4.1,0.4,6.1,0.4c-0.2-1.7-0.2-4.6,1-7c1.8-3.4,9.3-8.1,17.4-5.3 c6.3,2.2,13.9,3.4,15.8,3.7c1.3-1.1,5.5-3.9,11.4-2.6c6.4,1.5,17.4,2.9,17.5,2.9c0.2,0,13.6,2.4,27.2,9.2 c4.7,2.4,9.8,5.1,15.2,8.3c6.6,3.9,13.6,6.6,20.8,8.1c3.4,0.7,6.7,1.7,9.9,2.8c10.3,3.8,197.1,81.8,199,82.5l0.7,0.3l0,0.8 c-0.1,1.7-8.8,167-8.8,169.4l0.1,0.7l-0.7,0.2C664.6,492,664.6,492,664.4,492z M431,312.1c2.2,0,4.3,0.4,6.4,1.1l8.4,3.1 c26.9,15.2,108.4,78.1,109.2,78.7c34.4,29.9,97.6,84.8,108.3,93.8c0.7-15.7,5.6-108.8,8.7-166.7 c-12.6-5.3-188.2-78.5-198.2-82.2c-3-1.1-6.2-2-9.6-2.7c-7.5-1.6-14.7-4.4-21.5-8.3c-5.3-3.1-10.4-5.9-15.1-8.2 c-13.3-6.7-26.4-9-26.6-9c-0.1,0-11.2-1.4-17.7-2.9c-5.9-1.4-9.7,2.2-9.8,2.4l-0.4,0.4l-0.5-0.1c-0.4,0-9.2-1.2-16.7-3.8 c-6.9-2.4-13.4,1.6-14.8,4.3c-1.4,2.7-0.7,6.8-0.6,6.8l0.2,1.3l-1.3,0c-2.5,0.1-5.1-0.2-7.6-0.4c-5.9-0.6-11.5-1.1-15.3,2.6 c-4.2,4-3.9,7.1-3.7,8.2c0.1,0.5-0.1,1-0.5,1.4c-0.4,0.3-1,0.4-1.5,0.1c-7-3.6-14.2-6.9-21.6-9.6c-4.8-1.8-11.3-4.1-15.5-5.6 c-2.8-1-5.3-1.2-7.6-0.6c-2.4,0.6-4,2.7-4,5c0,3,1.1,5.3,3.4,6.9c4.1,2.8,16,10.2,26.6,16.7c4.6,2.9,9,5.6,12.5,7.7 c11.5,7.2,27.6,19.4,32.3,25.4c2.1,2.7,4.8,5.6,7.2,8.2c3,3.3,5.4,5.9,6.2,7.4c1.6,3.1,1.9,5.7,0.9,7.8c-1,2-3.1,3.4-6.4,4 c-4.3,0.8-13.7,1.5-22.7,2.1c-8.6,0.6-17.5,1.2-21.2,1.9c-7.1,1.4-14.6,5-14.3,10.7c0.3,5.8,1.5,9.8,13.8,11.9 c7.4,1.2,15.6,0.6,23.5,0.1c5.6-0.4,10.8-0.8,15.7-0.5c2.1,0.1,4.2,0.2,6.3,0.4c10.1,0.7,20.6,1.4,29.2-1.5 c11.5-3.8,19.9-6.5,31.5-8.5c4.4-0.8,8.8-2.7,13-5.8C423.1,313.4,427.1,312.1,431,312.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1228_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_587_",
    className: "st1",
    d: "M299.4,328.8c0.9-0.3,1.6-1.1,1.6-2.1c0.1-2.7,0.1-8.2-1.2-11.1 c-1.8-3.8-9-1.8-13.2,0.1c-0.7,1.2-1.1,2.6-1,4.2c0.1,2.7,0.5,5,1.8,6.9C287.7,327,292.9,330.9,299.4,328.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_589_",
    className: "st2",
    d: "M295.4,330.5c-4.8,0-8.2-2.4-8.7-2.8l-0.3-0.3c-1.5-2.3-1.8-4.9-2-7.4 c-0.1-1.7,0.3-3.3,1.2-4.8l0.2-0.3l0.3-0.1c1.3-0.6,7.8-3.5,11.9-2c1.2,0.5,2.1,1.2,2.7,2.4c1.4,3,1.4,8.5,1.3,11.6 c-0.1,1.4-1,2.6-2.3,3.1l0,0C298.2,330.3,296.8,330.5,295.4,330.5z M288.2,326.1c0.9,0.6,5.4,3.5,10.9,1.7l0,0 c0.5-0.2,0.8-0.6,0.9-1.1c0.1-2.3,0.2-7.9-1.1-10.6c-0.3-0.6-0.7-1-1.4-1.2c-2.4-0.9-6.6,0.2-10,1.8c-0.6,1-0.8,2.1-0.7,3.3 C286.8,322,287.1,324.3,288.2,326.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1230_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_553_",
    className: "st1",
    d: "M270.8,221.9c4.6-2.9,6.3-4.1,1.8-6.7l0,0c-2.4-1-5.8-1.3-7.4-0.4 c-2.2,1.2-3.4,2.8-3.9,5.1C261.4,219.9,266.3,224.8,270.8,221.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_583_",
    className: "st2",
    d: "M267.8,223.9c-3.6,0-6.8-2.8-7.3-3.4l-0.3-0.4l0.1-0.5c0.5-2.6,1.9-4.5,4.4-5.8 c2.1-1.1,5.9-0.7,8.4,0.4c1.7,1,3.2,2.1,3.3,3.7c0,1.8-1.8,3-4.9,5l-0.6-0.9l0.6,0.9C270.2,223.6,269,223.9,267.8,223.9z  M262.5,219.5c1.1,0.9,4.6,3.5,7.7,1.5l0,0c1.8-1.2,3.9-2.5,3.9-3.1c0-0.1-0.1-0.6-2.1-1.8c-2-0.9-5.1-1.1-6.4-0.4 C264,216.6,263,217.8,262.5,219.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1219_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_581_",
    className: "st2",
    d: "M329.2,237.6c-10.6-2.7-18-5.8-18.1-5.8l0.8-2c0.1,0,7.4,3.1,17.8,5.7L329.2,237.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1220_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_580_",
    className: "st2",
    d: "M339.5,219.9l-0.1-2.2c0.1,0,7-0.3,12.4-1.7l0.5,2.1 C346.7,219.6,339.8,219.9,339.5,219.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1222_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_579_",
    className: "st2",
    d: "M382.4,213.1c-4.5-0.8-9.7-1.7-9.7-1.7l0.4-2.1c0,0,5.3,0.9,9.8,1.8L382.4,213.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1233_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_577_",
    className: "st2",
    d: "M328.7,249.7c0-0.1-1.1-7.4,6.5-10.2l0.7,2c-5.9,2.2-5.2,7.6-5.1,7.9L328.7,249.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1239_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_576_",
    className: "st2",
    d: "M352.3,227.2l-2.1-0.6c0.1-0.3,2.2-7,13.9-7.8l0.1,2.1 C354.2,221.7,352.4,227,352.3,227.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1240_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_574_",
    className: "st2",
    d: "M388.7,214.5l-1.8-1.2c1.3-2.1,5.3-5.7,10.9-4.3l-0.5,2.1 C391.7,209.8,388.7,214.4,388.7,214.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1242_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_573_",
    className: "st2",
    d: "M319.4,316.3l-2.1-0.3c0.2-1.3,0.6-2.7,1.3-4.1l2,0.9 C320,313.9,319.6,315.1,319.4,316.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1241_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_571_",
    className: "st2",
    d: "M320.6,326.9c-0.1-0.1-3.4-3.2-3.5-8.4l2.2-0.1c0.1,4.3,2.8,6.9,2.9,6.9L320.6,326.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1243_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_570_",
    className: "st2",
    d: "M354.5,305.6c-1.1-4.8-6.5-12-6.6-12.1l1.7-1.3c0.2,0.3,5.7,7.6,7,12.9L354.5,305.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1244_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_569_",
    className: "st2",
    d: "M436.6,315.3c-1.5-0.6-3.1-1.1-4.7-1.6c-4.7-1.5-10.5-3.3-17.8-9.5l1.4-1.6 c7,6,12.3,7.6,17.1,9.1c1.7,0.5,3.4,1,4.9,1.7L436.6,315.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1245_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_567_",
    className: "st2",
    d: "M411.3,301.5c-0.2-0.1-3.9-3.2-5.1-7.5l2.1-0.6c1,3.6,4.3,6.3,4.4,6.4L411.3,301.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1246_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_566_",
    className: "st2",
    d: "M442.1,245l-1.6-1.4c0.4-0.5,10.2-11.1,24.1-8.5l-0.4,2.1 C451.5,234.8,442.2,244.9,442.1,245z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1248_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_565_",
    className: "st2",
    d: "M433.9,248.3l-1.8-1.2c0.2-0.2,4-5.8,8.2-7.9l1,1.9C437.6,243,434,248.3,433.9,248.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1251_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_563_",
    className: "st2",
    d: "M295.3,231.3l-1.7-1.3c2.2-3,4.8-4.7,7.9-5.1l0.3,2.1 C299.2,227.4,297.1,228.8,295.3,231.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1249_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_562_",
    className: "st2",
    d: "M293.2,234.9l-2-0.7c0,0,0.4-1.2,1.4-2.8l1.8,1.1C293.6,233.9,293.2,234.9,293.2,234.9z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1250_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_560_",
    className: "st2",
    d: "M295.2,325.9c-0.1-0.3-3.1-6.8,2-12.6l1.6,1.4c-4.2,4.7-1.8,10.1-1.7,10.3L295.2,325.9z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1252_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_559_",
    x: 366.6,
    y: 218.4,
    transform: "matrix(0.9999 -1.501479e-02 1.501479e-02 0.9999 -3.2538 5.5626)",
    className: "st2",
    width: 4.4,
    height: 2.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1253_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_558_",
    className: "st2",
    d: "M342.7,218.8c-0.1-0.4-0.9-3.7,0.7-5.8l1.8,1.3c-0.8,1.1-0.5,3.3-0.3,4L342.7,218.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1254_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_557_",
    className: "st2",
    d: "M329.5,255.7c-0.2-0.7-0.7-2.9-0.5-4l2.1,0.4c-0.1,0.4,0.2,1.9,0.5,3.1L329.5,255.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1255_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_555_",
    className: "st2",
    d: "M524.1,366.2c-1.7-11.3-1.8-29.2,6.9-50l2,0.8c-8.5,20.3-8.4,37.7-6.7,48.8L524.1,366.2 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1258_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_554_",
    className: "st2",
    d: "M535.6,312l-2-0.9c0.1-0.2,2.9-6.2,9.3-12.8l1.6,1.5C538.4,306.2,535.6,312,535.6,312z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1256_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1257_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_534_",
    className: "st3",
    d: "M553.3,411.4c-5.8-4.9-10.6-11-13.8-17.9c-5.2-11.1-10.1-29.2-5.8-53.5 c6.5-36.5,28.9-52.6,43.7-59c4.3-1.8,9.2-1.9,13.5-0.1l84.4,33.7L664.3,491l-20.1-3.1L553.3,411.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_549_",
    className: "st1",
    d: "M665.3,492.2l-21.6-3.4l-0.2-0.2l-90.9-76.4c-6.1-5.1-10.9-11.3-14.1-18.3 c-5.1-11-10.3-29.3-5.9-54.1c6.9-38.4,30.7-53.9,44.4-59.8c4.6-2,9.7-2,14.4-0.1l85.1,34l-0.1,0.8L665.3,492.2z M644.6,486.8 l18.6,2.9l11-174.4l-83.7-33.4c-4.1-1.7-8.7-1.6-12.7,0.1c-13.2,5.7-36.4,20.7-43.1,58.2c-4.3,24.2,0.7,42.1,5.7,52.8 c3.1,6.7,7.7,12.6,13.6,17.6L644.6,486.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1259_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_548_",
    className: "st0",
    d: "M549.7,320.1l-2-0.7c0.3-0.9,8.4-21.9,37-35.1l0.9,2C557.8,299,549.8,319.9,549.7,320.1 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1260_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_547_",
    className: "st0",
    d: "M544.8,335.3l-2.1-0.5c0.1-0.3,1.7-6.9,3.3-11.2l2,0.8 C546.4,328.6,544.8,335.2,544.8,335.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4554_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4563_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_536_",
    className: "st1",
    d: "M260.2,230.9c-0.2-0.2-5.2-4.5-3.6-11.7l1.2,0.3c-1.4,6.6,3.2,10.5,3.2,10.5L260.2,230.9 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4567_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_535_",
    className: "st1",
    d: "M258.7,217.3l-1.2-0.5c0.1-0.2,1.6-4,4.7-5.3l0.5,1.1 C260.1,213.8,258.7,217.2,258.7,217.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1742_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_532_",
    className: "st0",
    d: "M532.8,257.6l20.3,8.7L532.8,257.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_533_",
    x: 542.3,
    y: 250.8,
    transform: "matrix(0.3926 -0.9197 0.9197 0.3926 88.931 658.4407)",
    className: "st1",
    width: 1.2,
    height: 22.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1743_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_530_",
    className: "st0",
    d: "M558,268.1l9,3.7L558,268.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_531_",
    x: 561.8,
    y: 265.1,
    transform: "matrix(0.3775 -0.926 0.926 0.3775 100.1526 688.9089)",
    className: "st1",
    width: 1.2,
    height: 9.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3782_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_528_",
    className: "st0",
    d: "M602.9,279.2l38.8,16.4L602.9,279.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_529_",
    x: 621.6,
    y: 266.3,
    transform: "matrix(0.3896 -0.921 0.921 0.3896 115.1911 748.5111)",
    className: "st1",
    width: 1.2,
    height: 42.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3781_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_524_",
    className: "st0",
    d: "M589.8,273.6l8.7,3.7L589.8,273.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_525_",
    x: 593.6,
    y: 270.8,
    transform: "matrix(0.3897 -0.9209 0.9209 0.3897 108.9275 715.3287)",
    className: "st1",
    width: 1.2,
    height: 9.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3774_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4571_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4578_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_517_",
    className: "st0",
    d: "M310.8,76.2c5.3-6.6,7.1-18.3,3.9-26c-2.9-7.1-14.6-10-19.6-4.1 c-2.2,2.6,4.8,13.2,2.4,18.8c-3.4,7.9-10.5,13-8.8,17.6c0,0,1,1.9,3.9,1.5c1.2-0.2,2.6-0.2,2.8-0.7c0.6-1.4,1.9-3.9,4.3-4.1 l0,0C303,81.5,307.2,80.6,310.8,76.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_518_",
    className: "st1",
    d: "M291.9,84.6c-2.7,0-3.7-1.8-3.7-1.9c-1.2-3.2,1.1-6.3,3.7-10c1.7-2.4,3.7-5.1,5-8.2 c1.2-2.8-0.2-7.1-1.4-10.8c-1.2-3.7-2.1-6.6-0.9-8.1c2.3-2.7,6.1-3.9,10.3-3.2c4.7,0.7,8.8,3.7,10.4,7.5 c3.3,7.9,1.5,19.9-4,26.7l0,0c-3.6,4.4-8.1,5.7-11.7,3.2c-1.9,0.4-3,2.5-3.5,3.7c-0.3,0.7-1.3,0.8-2.5,1 c-0.3,0-0.5,0.1-0.8,0.1C292.5,84.6,292.2,84.6,291.9,84.6z M289.3,82.2c0,0,0.8,1.4,3.3,1.1c0.3,0,0.5-0.1,0.8-0.1 c0.5-0.1,1.4-0.1,1.5-0.3c0.6-1.5,2-4.1,4.7-4.4l0.3-0.1l0.2,0.2c3.1,2.2,7,1.1,10.2-2.8c5.1-6.3,6.9-18,3.8-25.4 c-1.4-3.4-5.1-6-9.4-6.7c-3.7-0.6-7.1,0.5-9.1,2.8c-0.8,0.9,0.2,4,1.1,6.9c1.3,4,2.8,8.5,1.4,11.7c-1.4,3.2-3.4,6-5.1,8.4 C290.4,77,288.4,79.7,289.3,82.2L289.3,82.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4577_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_513_",
    className: "st0",
    d: "M304.8,75.2c5.3-6.6,7.1-18.3,3.9-26.1c-2.8-6.8-9.7-7.8-14.4-2.3 c-5.1,6.1-7.1,17-4.7,24.8c0.2,0.7,0.2,1.5-0.1,2.2c-0.7,1.6-1.9,5-0.7,8.5c0.1,0.4,0.5,0.4,0.7-0.1c0.6-1.4,1.9-3.9,4.3-4.1 l0,0C297,80.5,301.2,79.6,304.8,75.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_514_",
    className: "st1",
    d: "M289.1,83.3C289.1,83.3,289,83.3,289.1,83.3c-0.4,0-0.8-0.3-0.9-0.7 c-1.2-3.7-0.1-7.2,0.7-9c0.2-0.5,0.3-1.1,0.1-1.7c-2.5-8.1-0.4-19.2,4.8-25.4c2.4-2.8,5.5-4.2,8.5-3.7c3,0.5,5.5,2.7,6.9,6.1 c3.3,7.9,1.5,19.9-4,26.7l0,0c-3.6,4.4-8.1,5.7-11.7,3.2c-1.9,0.4-3,2.5-3.5,3.7C289.9,83,289.5,83.3,289.1,83.3z M301.1,43.9 c-2.2,0-4.5,1.2-6.4,3.4c-5,5.9-7,16.5-4.6,24.2c0.3,0.9,0.2,1.8-0.1,2.6c-0.7,1.5-1.6,4.3-0.9,7.4c0.8-1.6,2.2-3.7,4.5-4 l0.3-0.1l0.2,0.2c3.1,2.2,7,1.1,10.2-2.8l0,0c5.1-6.3,6.9-18,3.8-25.4c-1.2-3-3.4-5-6-5.4C301.8,44,301.5,43.9,301.1,43.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4573_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4576_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_509_",
    className: "st0",
    d: "M297.4,56.7c-0.8,1-1.9,0.9-2.4-0.4c-0.5-1.2-0.2-3.1,0.6-4.1c0.8-1,1.9-0.9,2.4,0.4 C298.6,53.8,298.3,55.7,297.4,56.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_510_",
    className: "st1",
    d: "M296.3,58c-0.1,0-0.2,0-0.2,0c-0.7-0.1-1.2-0.6-1.5-1.4c-0.6-1.4-0.2-3.5,0.7-4.7 c0.5-0.7,1.2-1,1.9-0.9c0.7,0.1,1.2,0.6,1.5,1.4c0.6,1.4,0.2,3.5-0.7,4.7h0C297.5,57.7,296.9,58,296.3,58z M296.9,52.2 c-0.2,0-0.5,0.2-0.7,0.4c-0.7,0.9-1,2.5-0.6,3.5c0.1,0.4,0.4,0.6,0.6,0.6c0.2,0,0.5-0.1,0.7-0.4l0,0c0.7-0.9,0.9-2.5,0.6-3.5 C297.4,52.4,297.2,52.2,296.9,52.2C296.9,52.2,296.9,52.2,296.9,52.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4575_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_505_",
    className: "st0",
    d: "M300.1,63.7c-0.8,1-1.9,0.9-2.4-0.4c-0.5-1.2-0.2-3.1,0.6-4.1c0.8-1,1.9-0.9,2.4,0.4 S301,62.6,300.1,63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_506_",
    className: "st1",
    d: "M299,64.9c-0.1,0-0.2,0-0.2,0c-0.7-0.1-1.2-0.6-1.5-1.4c-0.6-1.4-0.2-3.5,0.7-4.7 c0.5-0.7,1.2-1,1.9-0.9c0.7,0.1,1.2,0.6,1.5,1.4c0.6,1.4,0.2,3.5-0.7,4.7C300.1,64.6,299.5,64.9,299,64.9z M299.6,59.1 c-0.2,0-0.5,0.2-0.7,0.4c-0.7,0.9-1,2.5-0.6,3.5c0.1,0.4,0.4,0.6,0.6,0.6c0.2,0,0.5-0.1,0.7-0.4h0c0.7-0.9,0.9-2.5,0.6-3.5 C300,59.4,299.8,59.1,299.6,59.1C299.6,59.1,299.6,59.1,299.6,59.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4574_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_501_",
    className: "st0",
    d: "M302.8,70.6c-0.8,1-1.9,0.9-2.4-0.4c-0.5-1.2-0.2-3.1,0.6-4.1c0.8-1,1.9-0.9,2.4,0.4 C303.9,67.7,303.6,69.6,302.8,70.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_502_",
    className: "st1",
    d: "M301.6,71.9c-0.1,0-0.2,0-0.2,0c-0.7-0.1-1.2-0.6-1.5-1.4c-0.6-1.4-0.2-3.5,0.7-4.7 c0.5-0.7,1.2-1,1.9-0.9c0.7,0.1,1.2,0.6,1.5,1.4c0.6,1.4,0.2,3.5-0.7,4.7C302.8,71.6,302.2,71.9,301.6,71.9z M302.2,66.1 c-0.2,0-0.5,0.2-0.7,0.4c-0.7,0.9-0.9,2.5-0.6,3.5c0.1,0.4,0.4,0.6,0.6,0.6c0.2,0,0.5-0.1,0.7-0.4h0c0.7-0.9,0.9-2.5,0.6-3.5 C302.7,66.3,302.5,66.1,302.2,66.1C302.3,66.1,302.3,66.1,302.2,66.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4332_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4334_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4382_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_495_",
    transform: "matrix(0.4561 -0.8899 0.8899 0.4561 -60.386 257.0701)",
    className: "st1",
    cx: 180.1,
    cy: 177.9,
    rx: 19.2,
    ry: 33.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_497_",
    className: "st1",
    d: "M193.2,201.4c-14.8,0-32.8-9.5-40.7-21.7c-4.1-6.3-4.9-12.4-2.5-17.1 c2.4-4.8,7.9-7.6,15.4-8c15.1-0.7,34.1,9,42.4,21.7l0,0c4.1,6.3,4.9,12.4,2.5,17.1c-2.4,4.8-7.9,7.6-15.4,8 C194.3,201.4,193.8,201.4,193.2,201.4z M167.1,155.7c-0.5,0-1.1,0-1.6,0c-7,0.4-12.1,2.9-14.3,7.3c-2.2,4.4-1.4,10,2.4,15.9 c8,12.4,26.5,21.9,41.2,21.1c7-0.4,12.1-2.9,14.3-7.3c2.2-4.4,1.4-10-2.4-15.9l0,0C199,165,181.5,155.7,167.1,155.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4381_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_488_",
    transform: "matrix(0.4561 -0.8899 0.8899 0.4561 -57.8225 256.869)",
    className: "st0",
    cx: 181.2,
    cy: 175.7,
    rx: 19.2,
    ry: 33.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_489_",
    className: "st1",
    d: "M194.3,199.2c-14.8,0-32.8-9.5-40.7-21.7c-4.1-6.3-4.9-12.4-2.5-17.1 c2.4-4.8,7.9-7.6,15.4-8c15.1-0.7,34.1,9,42.4,21.7l0,0c4.1,6.3,4.9,12.4,2.5,17.1c-2.4,4.8-7.9,7.6-15.4,8 C195.4,199.2,194.9,199.2,194.3,199.2z M168.2,153.5c-0.5,0-1.1,0-1.6,0c-7,0.4-12.1,2.9-14.3,7.3c-2.2,4.4-1.4,10,2.4,15.9 c8,12.4,26.5,21.9,41.2,21.1c7-0.4,12.1-2.9,14.3-7.3c2.2-4.4,1.4-10-2.4-15.9C200.1,162.8,182.6,153.5,168.2,153.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4337_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4364_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_482_",
    transform: "matrix(0.4561 -0.8899 0.8899 0.4561 -50.1734 256.2985)",
    className: "st1",
    cx: 184.6,
    cy: 169.2,
    rx: 19.2,
    ry: 33.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_484_",
    className: "st1",
    d: "M197.7,192.6c-14.8,0-32.8-9.5-40.7-21.7c-4.1-6.3-4.9-12.4-2.5-17.1 c2.4-4.8,7.9-7.6,15.4-8c15.1-0.8,34.1,9,42.4,21.7l0,0c4.1,6.3,4.9,12.4,2.5,17.1c-2.4,4.8-7.9,7.6-15.4,8 C198.8,192.6,198.2,192.6,197.7,192.6z M171.5,147c-0.5,0-1.1,0-1.6,0c-7,0.4-12.1,2.9-14.3,7.3c-2.2,4.4-1.4,10,2.4,15.9 c8,12.4,26.5,21.9,41.2,21.1c7-0.4,12.1-2.9,14.3-7.3c2.2-4.4,1.4-10-2.4-15.9l0,0C203.4,156.2,186,147,171.5,147z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4361_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_475_",
    transform: "matrix(0.4561 -0.8899 0.8899 0.4561 -47.6099 256.0974)",
    className: "st0",
    cx: 185.7,
    cy: 167,
    rx: 19.2,
    ry: 33.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_477_",
    className: "st1",
    d: "M198.8,190.4c-14.8,0-32.8-9.5-40.7-21.7c-4.1-6.3-4.9-12.4-2.5-17.1 c2.4-4.8,7.9-7.6,15.4-8c15.1-0.7,34.1,9,42.4,21.7l0,0c4.1,6.3,4.9,12.4,2.5,17.1c-2.4,4.8-7.9,7.6-15.4,8 C199.9,190.4,199.3,190.4,198.8,190.4z M172.7,144.8c-0.5,0-1.1,0-1.6,0c-7,0.4-12.1,2.9-14.3,7.3c-2.2,4.4-1.4,10,2.4,15.9 c8,12.4,26.5,21.9,41.2,21.1c7-0.4,12.1-2.9,14.3-7.3c2.2-4.4,1.4-10-2.4-15.9l0,0C204.6,154,187.1,144.8,172.7,144.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4359_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4360_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_470_",
    className: "st0",
    d: "M181.1,153.2c1.3,1.9,0.4,3.6-1.9,3.7c-2.3,0.1-5.2-1.4-6.4-3.3 c-1.3-1.9-0.4-3.6,1.9-3.7C177,149.8,179.8,151.3,181.1,153.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_471_",
    className: "st1",
    d: "M178.9,157.5c-2.5,0-5.4-1.5-6.7-3.6c-0.7-1.1-0.9-2.3-0.4-3.2 c0.5-0.9,1.5-1.4,2.8-1.5c2.6-0.1,5.6,1.4,7,3.6h0c0.7,1.1,0.9,2.3,0.4,3.2c-0.5,0.9-1.5,1.4-2.8,1.5 C179.1,157.5,179,157.5,178.9,157.5z M174.9,150.5c-0.1,0-0.1,0-0.2,0c-0.9,0-1.5,0.3-1.8,0.8c-0.3,0.5-0.1,1.2,0.3,1.9 c1.1,1.7,3.8,3.1,5.9,3c0.9,0,1.5-0.3,1.8-0.8c0.3-0.5,0.1-1.2-0.3-1.9l0,0C179.5,151.8,176.9,150.5,174.9,150.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4445_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_464_",
    className: "st0",
    d: "M179.9,155.4c-1.3-1.9-4.1-3.4-6.4-3.3c-0.5,0-0.8,0.1-1.2,0.3c0.1,0.4,0.2,0.7,0.5,1.1 c1.3,1.9,4.1,3.4,6.4,3.3c0.5,0,0.8-0.1,1.2-0.3C180.3,156.2,180.2,155.8,179.9,155.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_466_",
    className: "st1",
    d: "M179,157.4c-2.5,0-5.4-1.5-6.7-3.6c-0.3-0.4-0.5-0.8-0.6-1.3l-0.1-0.5l0.5-0.2 c0.4-0.2,0.9-0.3,1.4-0.3c2.6-0.1,5.6,1.4,7,3.6c0.3,0.4,0.5,0.9,0.6,1.3l0.1,0.5l-0.5,0.2c-0.4,0.2-0.9,0.3-1.4,0.3 C179.2,157.4,179.1,157.4,179,157.4z M173.1,152.8c0.1,0.1,0.1,0.3,0.2,0.4c1.1,1.7,3.8,3.1,5.9,3c0.1,0,0.3,0,0.4-0.1 c-0.1-0.1-0.1-0.3-0.2-0.4l0,0c-1.1-1.7-3.8-3.1-5.9-3C173.4,152.7,173.2,152.8,173.1,152.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4355_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4356_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_458_",
    className: "st0",
    d: "M199.4,162.4c-1.4,1.1-4.3,0.6-6.5-1c-2.2-1.6-2.9-3.8-1.6-4.9c1.4-1.1,4.3-0.6,6.5,1 S200.7,161.4,199.4,162.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_460_",
    className: "st1",
    d: "M197.3,163.6c-1.5,0-3.3-0.6-4.9-1.7c-1.6-1.1-2.5-2.6-2.5-3.9c0-0.8,0.3-1.5,0.9-2 c1.6-1.3,4.8-0.8,7.3,1c1.6,1.1,2.5,2.6,2.5,3.9c0,0.8-0.3,1.5-0.9,2l0,0C199.1,163.4,198.3,163.6,197.3,163.6z  M193.3,156.6c-0.7,0-1.2,0.1-1.6,0.5c-0.3,0.2-0.5,0.6-0.5,1c0,0.9,0.8,2,2,2.9c2,1.4,4.6,1.9,5.8,1l0,0 c0.3-0.2,0.5-0.6,0.5-1c0-0.9-0.8-2-2-2.9C196.1,157.1,194.5,156.6,193.3,156.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4351_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4352_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_453_",
    transform: "matrix(0.4561 -0.8899 0.8899 0.4561 -43.0317 275.7865)",
    className: "st0",
    cx: 204.1,
    cy: 173.1,
    rx: 3,
    ry: 5.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_454_",
    className: "st1",
    d: "M206.1,177.2c-0.7,0-1.5-0.1-2.3-0.4l0,0c-2.9-1-5.1-3.3-5.1-5.3 c0-0.8,0.4-1.5,1.1-1.9c1.1-0.7,2.8-0.8,4.6-0.2c2.9,1,5.1,3.3,5.1,5.3c0,0.8-0.4,1.5-1.1,1.9 C207.8,177,207,177.2,206.1,177.2z M204.2,175.7c1.4,0.5,2.8,0.5,3.5-0.1c0.3-0.2,0.5-0.5,0.5-0.9c0.1-1.5-1.9-3.3-4.2-4.1 c-1.4-0.5-2.8-0.5-3.5,0.1c-0.3,0.2-0.5,0.5-0.5,0.9C199.9,173,201.8,174.9,204.2,175.7L204.2,175.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4347_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4348_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_447_",
    className: "st0",
    d: "M190.3,180.8c-1.3-1.9-0.4-3.6,1.9-3.7c2.3-0.1,5.2,1.4,6.4,3.3 c1.3,1.9,0.4,3.6-1.9,3.7C194.5,184.2,191.6,182.7,190.3,180.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_449_",
    className: "st1",
    d: "M196.5,184.7c-2.5,0-5.4-1.5-6.7-3.6c-0.7-1.1-0.9-2.3-0.4-3.2 c0.5-0.9,1.5-1.4,2.8-1.5c2.5-0.1,5.6,1.4,7,3.6c0.7,1.1,0.9,2.3,0.4,3.2c-0.5,0.9-1.5,1.4-2.8,1.5 C196.7,184.7,196.6,184.7,196.5,184.7z M192.5,177.7c-0.1,0-0.1,0-0.2,0c-0.9,0-1.5,0.3-1.8,0.8c-0.3,0.5-0.1,1.2,0.3,1.9h0 c1.1,1.7,3.8,3.1,5.9,3c0.9,0,1.5-0.3,1.8-0.8c0.3-0.5,0.1-1.2-0.3-1.9C197.1,179,194.5,177.7,192.5,177.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4343_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4344_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_443_",
    className: "st0",
    d: "M172,171.6c1.4-1.1,4.3-0.6,6.5,1c2.2,1.6,2.9,3.8,1.6,4.9c-1.4,1.1-4.3,0.6-6.5-1 C171.4,174.8,170.7,172.6,172,171.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_444_",
    className: "st1",
    d: "M178.1,178.6c-1.5,0-3.3-0.6-4.9-1.7c-1.6-1.1-2.5-2.6-2.5-3.9c0-0.8,0.3-1.5,0.9-2 c1.6-1.3,4.8-0.8,7.3,1c1.6,1.1,2.5,2.6,2.5,3.9c0,0.8-0.3,1.5-0.9,2C179.9,178.4,179.1,178.6,178.1,178.6z M174.1,171.6 c-0.7,0-1.2,0.1-1.6,0.5c-0.3,0.2-0.5,0.6-0.5,1c0,0.9,0.8,2,2,2.9c2,1.4,4.6,1.9,5.8,1c0.3-0.2,0.5-0.6,0.5-1 c0-0.9-0.8-2-2-2.9C176.9,172.1,175.3,171.6,174.1,171.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4340_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4341_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_438_",
    transform: "matrix(0.4561 -0.8899 0.8899 0.4561 -52.1877 236.4091)",
    className: "st0",
    cx: 167.3,
    cy: 160.9,
    rx: 3,
    ry: 5.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_439_",
    className: "st1",
    d: "M169.3,165c-0.7,0-1.5-0.1-2.3-0.4c-2.9-1-5.1-3.3-5.1-5.3c0-0.8,0.4-1.5,1.1-1.9 c1.1-0.7,2.8-0.8,4.6-0.2c2.9,1,5.1,3.3,5.1,5.3c0,0.8-0.4,1.5-1.1,1.9C171,164.8,170.2,165,169.3,165z M165.3,158 c-0.6,0-1.2,0.1-1.6,0.4c-0.3,0.2-0.5,0.5-0.5,0.9c-0.1,1.5,1.9,3.3,4.2,4.1c1.4,0.5,2.8,0.5,3.5-0.1 c0.3-0.2,0.5-0.5,0.5-0.9c0.1-1.5-1.9-3.3-4.2-4.1l0,0C166.6,158.1,165.9,158,165.3,158z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4338_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4339_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_434_",
    className: "st0",
    d: "M185.8,165.4c1.3,0.4,2.3,1.5,2.3,2.4c0,0.9-1.1,1.2-2.4,0.8c-1.3-0.4-2.3-1.5-2.3-2.4 C183.4,165.3,184.5,165,185.8,165.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_435_",
    className: "st1",
    d: "M186.7,169.4c-0.4,0-0.8-0.1-1.3-0.2c-1.6-0.5-2.8-1.8-2.7-3c0-0.5,0.3-0.9,0.7-1.2 c0.6-0.4,1.6-0.5,2.6-0.1l0,0c1.6,0.5,2.8,1.8,2.7,3c0,0.5-0.3,0.9-0.7,1.2C187.7,169.3,187.2,169.4,186.7,169.4z  M184.7,165.9c-0.3,0-0.5,0.1-0.6,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.5,0.8,1.4,1.9,1.7c0.7,0.2,1.3,0.2,1.5,0 c0.1-0.1,0.1-0.1,0.1-0.2c0-0.5-0.8-1.4-1.9-1.7l0,0C185.2,165.9,184.9,165.9,184.7,165.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4384_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_429_",
    className: "st0",
    d: "M179.1,176.5c-1.3-1.9-4.1-3.4-6.4-3.3c-0.5,0-0.8,0.1-1.2,0.3c0.1,0.4,0.2,0.7,0.5,1.1 c1.3,1.9,4.1,3.4,6.4,3.3c0.5,0,0.8-0.1,1.2-0.3C179.5,177.3,179.4,176.9,179.1,176.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_430_",
    className: "st1",
    d: "M178.2,178.6c-2.5,0-5.4-1.5-6.7-3.6c-0.3-0.4-0.5-0.8-0.6-1.3l-0.1-0.5l0.5-0.2 c0.4-0.2,0.9-0.3,1.4-0.3c2.5-0.1,5.6,1.4,7,3.6l0,0c0.3,0.4,0.5,0.8,0.6,1.3l0.1,0.5l-0.5,0.2c-0.4,0.2-0.9,0.3-1.4,0.3 C178.3,178.6,178.3,178.6,178.2,178.6z M172.3,173.9c0.1,0.1,0.1,0.3,0.2,0.4c1.1,1.7,3.8,3.1,5.9,3c0.1,0,0.3,0,0.4-0.1 c-0.1-0.1-0.1-0.3-0.2-0.4h0c-1.1-1.7-3.8-3.1-5.9-3C172.6,173.9,172.4,173.9,172.3,173.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4440_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_425_",
    className: "st0",
    d: "M170.4,162.9c-1.3-1.9-4.1-3.4-6.4-3.3c-0.5,0-0.8,0.1-1.2,0.3c0.1,0.4,0.2,0.7,0.5,1.1 c1.3,1.9,4.1,3.4,6.4,3.3c0.5,0,0.8-0.1,1.2-0.3C170.8,163.7,170.6,163.3,170.4,162.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_426_",
    className: "st1",
    d: "M169.4,164.9c-2.5,0-5.4-1.5-6.7-3.6c-0.3-0.4-0.5-0.8-0.6-1.3l-0.1-0.5l0.5-0.2 c0.4-0.2,0.9-0.3,1.4-0.3c2.5-0.1,5.6,1.4,7,3.6l0,0c0.3,0.4,0.5,0.8,0.6,1.3l0.1,0.5l-0.5,0.2c-0.4,0.2-0.9,0.3-1.4,0.3 C169.6,164.9,169.5,164.9,169.4,164.9z M163.5,160.2c0.1,0.1,0.1,0.3,0.2,0.4c1.1,1.7,3.8,3.1,5.9,3c0.1,0,0.3,0,0.4-0.1 c-0.1-0.1-0.1-0.3-0.2-0.4h0c-1.1-1.7-3.8-3.1-5.9-3C163.8,160.2,163.7,160.2,163.5,160.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4441_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_421_",
    className: "st0",
    d: "M198.3,161.6c-1.3-1.9-4.1-3.4-6.4-3.3c-0.5,0-0.8,0.1-1.2,0.3c0.1,0.4,0.2,0.7,0.5,1.1 c1.3,1.9,4.1,3.4,6.4,3.3c0.5,0,0.8-0.1,1.2-0.3C198.7,162.4,198.5,162,198.3,161.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_422_",
    className: "st1",
    d: "M197.3,163.6c-2.5,0-5.4-1.5-6.7-3.6c-0.3-0.4-0.5-0.8-0.6-1.3l-0.1-0.5l0.5-0.2 c0.4-0.2,0.9-0.3,1.4-0.3c2.6-0.1,5.6,1.4,7,3.6l0,0c0.3,0.4,0.5,0.8,0.6,1.3l0.1,0.5l-0.5,0.2c-0.4,0.2-0.9,0.3-1.4,0.3 C197.5,163.6,197.4,163.6,197.3,163.6z M191.5,159c0.1,0.1,0.1,0.3,0.2,0.4c1.1,1.7,3.8,3.2,5.9,3c0.1,0,0.3,0,0.4,0 c-0.1-0.1-0.1-0.3-0.2-0.4c-1.1-1.7-3.8-3.1-5.9-3C191.7,158.9,191.6,159,191.5,159z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4442_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_417_",
    className: "st0",
    d: "M207.1,175.1c-1.3-1.9-4.1-3.4-6.4-3.3c-0.5,0-0.8,0.1-1.2,0.3c0.1,0.4,0.2,0.7,0.5,1.1 c1.3,1.9,4.1,3.4,6.4,3.3c0.5,0,0.8-0.1,1.2-0.3C207.5,175.9,207.4,175.5,207.1,175.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_418_",
    className: "st1",
    d: "M206.2,177.1c-2.5,0-5.4-1.5-6.7-3.6c-0.3-0.4-0.5-0.9-0.6-1.3l-0.1-0.5l0.5-0.2 c0.4-0.2,0.9-0.3,1.4-0.3c2.5-0.1,5.6,1.4,7,3.6l0,0c0.3,0.4,0.5,0.8,0.6,1.3l0.1,0.5l-0.5,0.2c-0.4,0.2-0.9,0.3-1.4,0.3 C206.4,177.1,206.3,177.1,206.2,177.1z M200.3,172.4c0.1,0.1,0.1,0.3,0.2,0.4c1.1,1.7,3.8,3.1,5.9,3c0.1,0,0.3,0,0.4,0 c-0.1-0.1-0.1-0.3-0.2-0.4c-1.1-1.7-3.8-3.1-5.9-3C200.6,172.4,200.4,172.4,200.3,172.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4443_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_413_",
    className: "st0",
    d: "M197.5,182.7c-1.3-1.9-4.1-3.4-6.4-3.3c-0.5,0-0.8,0.1-1.2,0.3c0.1,0.4,0.2,0.7,0.5,1.1 c1.3,1.9,4.1,3.4,6.4,3.3c0.5,0,0.8-0.1,1.2-0.3C197.9,183.5,197.7,183.1,197.5,182.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_414_",
    className: "st1",
    d: "M196.5,184.7c-2.5,0-5.4-1.5-6.7-3.6c-0.3-0.4-0.5-0.8-0.6-1.3l-0.1-0.5l0.5-0.2 c0.4-0.2,0.9-0.3,1.4-0.3c2.5-0.1,5.6,1.4,7,3.6h0c0.3,0.4,0.5,0.8,0.6,1.3l0.1,0.5l-0.5,0.2c-0.4,0.2-0.9,0.3-1.4,0.3 C196.7,184.7,196.6,184.7,196.5,184.7z M190.6,180.1c0.1,0.1,0.1,0.3,0.2,0.4c1.1,1.7,3.8,3.1,5.9,3c0.1,0,0.3,0,0.4-0.1 c-0.1-0.1-0.1-0.3-0.2-0.4c-1.1-1.7-3.8-3.1-5.9-3C190.9,180,190.8,180.1,190.6,180.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4365_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_407_",
    className: "st0",
    d: "M162.6,186.3c0,0-16.5-14.9-33.2-12.8l3.7-7.3c0,0,17.8-0.9,32.8,13.5L162.6,186.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_412_",
    className: "st1",
    d: "M162.2,186.8c-0.2-0.1-16.5-14.7-32.7-12.7l-1.2,0.1l4.4-8.6l0.4,0 c0.2,0,18.3-0.7,33.3,13.7l-0.9,0.9c-13.5-13-29.4-13.4-32-13.4l-3,5.9c16.3-1.3,31.8,12.5,32.5,13.1L162.2,186.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4368_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_411_",
    x: 132.3,
    y: 169.3,
    transform: "matrix(0.4555 -0.8902 0.8902 0.4555 -77.1244 213.6556)",
    className: "st1",
    width: 7.6,
    height: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4369_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_410_",
    x: 160.5,
    y: 182.3,
    transform: "matrix(0.4555 -0.8902 0.8902 0.4555 -73.4031 245.8806)",
    className: "st1",
    width: 7.6,
    height: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4370_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_409_",
    x: 197.7,
    y: 194.2,
    transform: "matrix(0.4555 -0.8902 0.8902 0.4555 -63.739 285.4249)",
    className: "st1",
    width: 7.6,
    height: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4371_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_408_",
    x: 186.7,
    y: 194.7,
    transform: "matrix(0.4555 -0.8902 0.8902 0.4555 -70.1215 275.9049)",
    className: "st1",
    width: 7.6,
    height: 1.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4444_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4411_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_403_",
    className: "st0",
    d: "M280.6,168.6l-51-16.9c-3.5-0.8-7.3-4.6-8.5-8.5l-12.5-26.6c-0.8-2.4,3.7-7.2,5.9-6.7 l58,13.3c2.2,0.5,4.5,2.9,5.3,5.3l9.2,29.7C288.2,162.1,284.1,169.4,280.6,168.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_404_",
    className: "st1",
    d: "M281.1,169.2c-0.2,0-0.4,0-0.7-0.1l-0.1,0l-51-16.9c-3.6-0.8-7.6-4.8-8.9-8.9l-12.5-26.5 c-0.5-1.7,0.7-3.8,2-5.2c1.2-1.3,3.1-2.6,4.5-2.3l58,13.3c2.4,0.5,4.9,3.1,5.7,5.7l9.2,29.7c0.9,2.9-0.8,7.1-2.9,9.3 C283.6,168.6,282.3,169.2,281.1,169.2z M280.8,168c1.2,0.3,2.4-0.8,3-1.5c1.9-2,3.4-5.7,2.6-8.1l-9.2-29.7 c-0.7-2.2-2.9-4.4-4.8-4.9l-58-13.3c-0.7-0.2-2.1,0.7-3.3,2c-1.3,1.4-2.1,3.1-1.8,4l12.5,26.5c1.2,3.8,4.8,7.4,8,8.2 L280.8,168z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4333_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_398_",
    className: "st0",
    d: "M279.8,168.4l-53.3-12.2c-3.5-0.8-7.3-4.6-8.5-8.5l-9.2-29.7c-0.8-2.4,0.4-4,2.5-3.5 l58,13.3c2.2,0.5,4.5,2.9,5.3,5.3l9.2,29.7C285.1,166.7,283.3,169.2,279.8,168.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_399_",
    className: "st1",
    d: "M281,169.2c-0.4,0-0.9-0.1-1.3-0.2l-53.3-12.2c-3.6-0.8-7.6-4.8-8.9-9l-9.2-29.7 c-0.5-1.5-0.3-2.8,0.5-3.6c0.7-0.7,1.6-0.9,2.8-0.7l58,13.3c2.4,0.5,4.9,3.1,5.7,5.7l9.2,29.7c0.7,2.3,0.5,4.3-0.7,5.5 C283.2,168.8,282.2,169.2,281,169.2z M210.7,115c-0.4,0-0.7,0.1-1,0.4c-0.4,0.5-0.5,1.4-0.2,2.4l9.2,29.7 c1.1,3.7,4.7,7.4,8,8.1l53.3,12.2c1.3,0.3,2.3,0.1,3-0.6c0.8-0.9,0.9-2.4,0.4-4.3l-9.2-29.7c-0.7-2.2-2.9-4.4-4.8-4.9 l-58-13.3C211.1,115,210.9,115,210.7,115z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4363_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4342_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_366_",
    className: "st0",
    d: "M274.1,154l-51-11.6c-1.2-0.3-2.5-1.6-2.9-3l-5.1-16.5c-0.4-1.4,0.2-2.2,1.4-2l51,11.6 c1.2,0.3,2.5,1.6,2.9,3l5.1,16.5C275.9,153.4,275.3,154.3,274.1,154z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_394_",
    className: "st1",
    d: "M274.5,154.7c-0.2,0-0.4,0-0.6-0.1L223,143c-1.4-0.3-2.9-1.8-3.4-3.4l-5.1-16.5 c-0.3-0.9-0.2-1.8,0.3-2.3c0.4-0.5,1.1-0.6,1.8-0.5l51,11.6c1.4,0.3,2.9,1.8,3.4,3.4l5.1,16.5c0.3,0.9,0.2,1.8-0.3,2.3 C275.5,154.5,275,154.7,274.5,154.7z M216.1,121.5c-0.1,0-0.3,0-0.4,0.1c-0.1,0.1-0.2,0.5,0,1.1l5.1,16.5 c0.4,1.1,1.5,2.3,2.5,2.5l51,11.6c0.2,0,0.5,0.1,0.6-0.1c0.1-0.1,0.2-0.5,0-1.1l-5.1-16.5c-0.4-1.1-1.5-2.3-2.5-2.5l-51-11.6 C216.3,121.5,216.2,121.5,216.1,121.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4350_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1809_",
    className: "st1",
    d: "M276.9,162.6l-51.4-11.7c-1.1-0.2-2.2-1.3-2.5-2.4v0c-0.3-1.1,0.3-1.7,1.4-1.5 l51.4,11.7c1.1,0.2,2.2,1.3,2.5,2.4l0,0C278.6,162.2,278,162.8,276.9,162.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4349_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4353_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_393_",
    x: 223.5,
    y: 140.4,
    transform: "matrix(0.3975 -0.9176 0.9176 0.3975 6.3818 291.7321)",
    className: "st1",
    width: 3.8,
    height: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4354_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_392_",
    x: 228.4,
    y: 141.5,
    transform: "matrix(0.3975 -0.9176 0.9176 0.3975 8.3175 296.9299)",
    className: "st1",
    width: 3.8,
    height: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4357_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_390_",
    x: 233.3,
    y: 142.6,
    transform: "matrix(0.3975 -0.9176 0.9176 0.3975 10.2531 302.1277)",
    className: "st1",
    width: 3.8,
    height: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4375_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_389_",
    x: 262.9,
    y: 149.4,
    transform: "matrix(0.3976 -0.9176 0.9176 0.3976 21.8611 333.3087)",
    className: "st1",
    width: 3.8,
    height: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4374_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_387_",
    x: 267.8,
    y: 150.5,
    transform: "matrix(0.3976 -0.9176 0.9176 0.3976 23.7971 338.5071)",
    className: "st1",
    width: 3.8,
    height: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4362_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_386_",
    x: 238.2,
    y: 143.8,
    transform: "matrix(0.3976 -0.9176 0.9176 0.3976 12.1843 307.3194)",
    className: "st1",
    width: 3.8,
    height: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4358_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_385_",
    x: 243.2,
    y: 144.9,
    transform: "matrix(0.3976 -0.9176 0.9176 0.3976 14.1198 312.5172)",
    className: "st1",
    width: 3.8,
    height: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4372_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_384_",
    x: 248.1,
    y: 146,
    transform: "matrix(0.3975 -0.9176 0.9176 0.3975 16.0595 317.7214)",
    className: "st1",
    width: 3.8,
    height: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4367_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_383_",
    x: 253,
    y: 147.1,
    transform: "matrix(0.3975 -0.9176 0.9176 0.3975 17.9948 322.9195)",
    className: "st1",
    width: 3.8,
    height: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4366_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_381_",
    x: 257.9,
    y: 148.3,
    transform: "matrix(0.3975 -0.9176 0.9176 0.3975 19.9309 328.1181)",
    className: "st1",
    width: 3.8,
    height: 1.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4373_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_380_",
    x: 246.8,
    y: 119,
    transform: "matrix(0.2227 -0.9749 0.9749 0.2227 51.8195 353.2826)",
    className: "st1",
    width: 1.2,
    height: 50.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4376_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4380_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_375_",
    className: "st1",
    d: "M250.5,141.3c-0.2,0-0.4,0-0.5-0.1c-1.2-0.3-2.4-1.4-2.8-2.5c-0.2-0.7-0.1-1.3,0.3-1.7 c0.4-0.4,1-0.6,1.7-0.4c1.2,0.3,2.4,1.4,2.8,2.5c0.2,0.7,0.1,1.3-0.3,1.7C251.4,141.2,251,141.3,250.5,141.3z M248.6,137.8 c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.1,0.2,0,0.5c0.2,0.7,1.1,1.5,1.9,1.7c0.3,0.1,0.5,0,0.5,0c0.1-0.1,0.1-0.2,0-0.5l0,0 c-0.2-0.7-1.1-1.5-1.9-1.7C248.8,137.9,248.7,137.8,248.6,137.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4379_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_371_",
    className: "st1",
    d: "M249,136.5c-0.2,0-0.4,0-0.5-0.1c-1.2-0.3-2.4-1.4-2.8-2.5c-0.2-0.7-0.1-1.3,0.3-1.7 c0.4-0.4,1-0.6,1.7-0.4c1.2,0.3,2.4,1.4,2.8,2.5l0,0c0.2,0.7,0.1,1.3-0.3,1.7C249.9,136.3,249.5,136.5,249,136.5z  M247.1,133c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.1,0.2,0,0.5c0.2,0.7,1.1,1.5,1.9,1.7c0.3,0.1,0.5,0,0.5,0 c0.1-0.1,0.1-0.2,0-0.5c-0.2-0.7-1.1-1.5-1.9-1.7C247.3,133,247.2,133,247.1,133z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4378_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_369_",
    x: 239.7,
    y: 135.6,
    transform: "matrix(0.8929 -0.4503 0.4503 0.8929 -35.2757 124.2383)",
    className: "st1",
    width: 7.4,
    height: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4377_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_368_",
    x: 242.1,
    y: 128.4,
    transform: "matrix(0.586 -0.8103 0.8103 0.586 -8.3269 252.2901)",
    className: "st1",
    width: 1.2,
    height: 11.8
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4439_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_361_",
    className: "st0",
    d: "M270.3,127.2l-61.6-39.4c-1.7-0.9-2.9-2.7-2.8-4l-2.4-1.8c0.1-1.3,4.6-5.7,6.2-4.8 l62.5,34.4c1.7,0.9,2.9,2.7,2.8,4l-0.6,5.9C274.3,122.7,271.9,128.1,270.3,127.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_362_",
    className: "st1",
    d: "M270.7,127.9c-0.3,0-0.5-0.1-0.7-0.2l0,0l-61.6-39.4c-1.7-0.9-3-2.8-3.1-4.3l-2.4-1.8 l0-0.3c0.1-1.3,2.8-4.1,4.7-5c1-0.5,1.8-0.6,2.5-0.3l62.5,34.4c1.9,1,3.2,3.1,3.1,4.7l-0.6,5.9c-0.1,1.1-1.8,5.3-3.6,6.2 C271.2,127.9,270.9,127.9,270.7,127.9z M270.6,126.7c0,0,0.1,0,0.3-0.1c1.2-0.6,2.8-4.2,2.9-5.2l0.6-5.9 c0.1-1-0.9-2.6-2.4-3.4l-62.5-34.4c-0.2-0.1-0.6-0.1-1.3,0.3c-1.6,0.9-3.5,2.9-3.9,3.8l2.3,1.7l0,0.3c-0.1,1,0.9,2.6,2.4,3.4 L270.6,126.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4383_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4335_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_355_",
    className: "st0",
    d: "M268.1,126.7l-62.5-34.4c-1.7-0.9-2.9-2.7-2.8-4l0.6-5.9c0.1-1.3,1.6-1.7,3.3-0.7 l62.5,34.4c1.7,0.9,2.9,2.7,2.8,4l-0.6,5.9C271.2,127.3,269.7,127.6,268.1,126.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_357_",
    className: "st1",
    d: "M269.8,127.9c-0.6,0-1.3-0.2-2.1-0.6l-62.5-34.4c-1.9-1-3.2-3.1-3.1-4.7l0.6-5.9 c0.1-0.7,0.4-1.3,1-1.6c0.8-0.4,2-0.3,3.2,0.3l62.5,34.3c1.9,1,3.2,3.1,3.1,4.7L272,126c-0.1,0.7-0.4,1.3-1,1.6 C270.6,127.8,270.2,127.9,269.8,127.9z M268.4,126.2c0.9,0.5,1.6,0.5,2,0.3c0.2-0.1,0.3-0.3,0.4-0.6l0.6-5.9 c0.1-1-0.9-2.6-2.4-3.4l-62.5-34.3c-0.9-0.5-1.6-0.5-2-0.3c-0.2,0.1-0.3,0.3-0.4,0.6l-0.6,5.9c-0.1,1,0.9,2.6,2.4,3.4 L268.4,126.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4336_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1760_",
    className: "st1",
    points: "207.2,82.1 214.6,97.3 227.4,104.4 219.6,88.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4345_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1758_",
    className: "st1",
    points: "227.3,93 234.6,108.3 247.5,115.4 239.6,99.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4346_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1756_",
    className: "st1",
    points: "247.3,104 254.6,119.3 267.5,126.4 259.6,110.8  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4532_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4540_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_350_",
    className: "st0",
    d: "M256.8,178.1L252,180l-5.6-2.4l-0.9-2.3c0,0,0,0,0,0l-6.1,1.4l-6.7,8.2L226,186 c-0.1,0-0.1,0.1-0.1,0.2l2.6,6.5c0,0,0,0,0,0.1l0,0l-3.1,0.7c0,0,0,0,0,0l2.6,6.6c0,0,0.1,0.3,0.2,0.4l1.6,1.5 c0.6,0.5,1.9,0.5,3-0.2l1.6-0.9c0.7,0.3,1.5,0.5,2.3,0.6c0.7,0.1,1.4,0.1,2.1,0.1l0.6,1.4l0,0.1c0.2,0.6,1,0.8,2.1,0.6 l3.4-0.8c1.2-0.3,2.3-1.2,2.3-2l0.1-1.1c1.9-0.8,3.7-1.8,5.2-3.1l1.5,0.2c1,0.2,2.4-0.4,3.1-1.2l1.8-2.3 c0.3-0.4,0.4-0.7,0.3-1l0-0.1l0,0l-1.9-4.8l1.2-0.7c1-0.6,1.4-1.4,1.1-2L256.8,178.1C256.8,178.1,256.8,178.1,256.8,178.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_351_",
    className: "st1",
    d: "M240.7,204.3c-1,0-1.7-0.4-1.9-1.1l-0.4-1c-0.7,0-1.2-0.1-1.7-0.1 c-0.8-0.1-1.5-0.3-2.2-0.5l-1.3,0.8c-1.4,0.8-3,0.8-3.8,0.1l-1.6-1.5c-0.2-0.2-0.3-0.4-0.4-0.6l-2.7-6.9l0.3-0.5l0.3-0.1 l2.3-0.6l-2.5-6.2l0.2-0.4c0.1-0.2,0.3-0.3,0.5-0.4l6.5-1.1l6.6-8.1l6.7-1.5l0.4,0.5l0.8,2l5.1,2.2l5.1-2l0.3,0.4l2.7,6.7 c0.2,0.2,0.2,0.6,0.1,1.1c-0.2,0.6-0.7,1.2-1.4,1.7l-0.7,0.4l1.8,4.5c0.2,0.6-0.1,1.2-0.4,1.6l-1.8,2.3 c-0.8,1-2.4,1.7-3.7,1.5l-1.2-0.2c-1.4,1.1-3,2-4.8,2.8l0,0.8c-0.1,1.1-1.3,2.2-2.8,2.5l-3.4,0.8 C241.3,204.3,241,204.3,240.7,204.3z M234.4,200.1l0.3,0.1c0.7,0.3,1.4,0.4,2.2,0.5c0.6,0.1,1.2,0.1,2,0.1l0.4,0l0.8,2 c0,0.2,0.5,0.3,1.4,0.1l3.4-0.8c1.1-0.3,1.8-1,1.8-1.4l0.1-1.5l0.4-0.2c1.9-0.8,3.6-1.8,5-3l0.2-0.2l1.8,0.3 c0.8,0.1,2-0.4,2.5-1l1.8-2.3c0.1-0.1,0.3-0.3,0.2-0.4l0-0.2l-2.1-5.3l1.7-1c0.6-0.3,0.8-0.7,0.9-0.9c0-0.1,0-0.2,0-0.2 l-2.5-6.1l-4.5,1.8l-6.1-2.6l-0.8-2l-5.4,1.3l-6.7,8.2l-6.3,1.1l2.6,6.6l-0.7,0.3l-2.4,0.6l2.4,5.9c0,0,0.1,0.1,0.1,0.2 l1.6,1.5c0.3,0.3,1.3,0.3,2.3-0.3L234.4,200.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4539_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_338_",
    className: "st0",
    d: "M252,176.5l-1.6,0.9c-0.7-0.3-1.4-0.5-2.3-0.6c-0.9-0.1-1.7-0.2-2.7-0.1l0.1-1.1 c0-0.8-0.9-1.2-2.2-0.9l-3.4,0.8c-1.2,0.3-2.3,1.2-2.3,2l-0.1,1.1c-1.9,0.8-3.7,1.8-5.2,3l-1.5-0.2c-1.1-0.2-2.4,0.4-3.1,1.2 l-1.8,2.3c-0.7,0.8-0.3,1.6,0.7,1.8l1.5,0.2c-0.5,1.4-0.6,2.6-0.2,3.8l-1.6,0.9c-1.1,0.6-1.5,1.6-0.9,2.2l1.6,1.5 c0.6,0.5,1.9,0.5,3-0.2l1.6-0.9c0.7,0.3,1.5,0.5,2.3,0.6c0.9,0.1,1.7,0.2,2.7,0.1l-0.1,1.1c0,0.8,0.9,1.2,2.2,0.9l3.4-0.8 c1.2-0.3,2.3-1.2,2.3-2l0.1-1.1c1.9-0.8,3.7-1.8,5.2-3.1l1.5,0.2c1.1,0.2,2.4-0.4,3.1-1.2l1.8-2.3c0.7-0.8,0.3-1.6-0.7-1.8 l-1.5-0.2c0.5-1.4,0.6-2.6,0.2-3.8l1.6-0.9c1.1-0.6,1.5-1.6,0.9-2.2l-1.6-1.5C254.5,175.8,253.1,175.9,252,176.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_345_",
    className: "st1",
    d: "M238.1,197.7c-0.6,0-1.1-0.2-1.5-0.5c-0.4-0.3-0.5-0.7-0.5-1.2l0-0.5 c-0.7,0-1.4-0.1-2.1-0.1c-0.7-0.1-1.5-0.3-2.2-0.5l-1.3,0.8c-1.4,0.8-3,0.8-3.8,0.1l-1.6-1.5c-0.3-0.3-0.5-0.8-0.4-1.2 c0.1-0.7,0.6-1.4,1.5-1.9l1.2-0.7c-0.2-0.9-0.2-1.9,0.1-3l-0.8-0.1c-0.7-0.1-1.3-0.5-1.5-1c-0.2-0.5-0.1-1.2,0.4-1.8l1.8-2.3 c0.8-1,2.4-1.7,3.7-1.5l1.2,0.2c1.4-1.1,3-2,4.7-2.8l0-0.8c0.1-1.1,1.3-2.2,2.8-2.5l3.4-0.8c1-0.2,1.9-0.1,2.4,0.4 c0.4,0.3,0.5,0.7,0.5,1.2l0,0.5c0.7,0,1.4,0.1,2.1,0.1c0.8,0.1,1.5,0.3,2.2,0.5l1.3-0.8c1.4-0.8,3-0.8,3.8-0.1l1.6,1.5 c0.3,0.3,0.5,0.8,0.4,1.2c-0.1,0.7-0.6,1.4-1.5,1.9l-1.2,0.7c0.2,0.9,0.2,1.9-0.1,3l0.8,0.1c0.7,0.1,1.3,0.5,1.5,1 c0.2,0.5,0.1,1.2-0.4,1.8l-1.8,2.3c-0.8,1-2.4,1.7-3.7,1.5l-1.2-0.2c-1.4,1.1-3,2-4.8,2.8l0,0.8c-0.1,1.1-1.3,2.2-2.8,2.5 l-3.4,0.8C238.7,197.6,238.4,197.7,238.1,197.7z M237.4,194.2l-0.1,1.8c0,0.1,0,0.1,0.1,0.2c0.2,0.2,0.7,0.3,1.3,0.1l3.4-0.8 c1.1-0.3,1.8-1,1.8-1.4l0.1-1.5l0.4-0.2c1.9-0.8,3.6-1.8,5-3l0.2-0.2l1.8,0.3c0.8,0.1,2-0.4,2.5-1l1.8-2.3 c0.2-0.3,0.2-0.4,0.2-0.5c0-0.1-0.2-0.2-0.5-0.3l-2.3-0.3l0.3-0.7c0.4-1.2,0.5-2.3,0.2-3.4l-0.2-0.5l2-1.2 c0.6-0.3,0.9-0.7,0.9-1c0-0.1,0-0.1-0.1-0.2l-1.6-1.5c-0.3-0.3-1.3-0.3-2.3,0.3l-1.8,1.1l-0.3-0.1c-0.7-0.3-1.4-0.4-2.2-0.5 c-0.8-0.1-1.6-0.2-2.6-0.1l-0.7,0l0.1-1.8c0-0.1,0-0.1-0.1-0.2c-0.2-0.2-0.7-0.3-1.3-0.1l-3.4,0.8c-1.1,0.3-1.8,1-1.8,1.4 l-0.1,1.5l-0.4,0.2c-1.9,0.8-3.6,1.8-5,3l-0.2,0.2l-1.8-0.3c-0.8-0.1-2,0.4-2.5,1l-1.8,2.3c-0.2,0.3-0.2,0.4-0.2,0.5 c0,0.1,0.2,0.2,0.5,0.3l2.3,0.3l-0.3,0.7c-0.5,1.2-0.5,2.3-0.2,3.4l0.2,0.5l-2,1.2c-0.6,0.3-0.9,0.7-0.9,1 c0,0.1,0,0.1,0.1,0.2l1.6,1.5c0.3,0.3,1.3,0.3,2.3-0.3l1.8-1.1l0.3,0.1c0.7,0.3,1.4,0.4,2.2,0.5c0.8,0.1,1.6,0.2,2.5,0.1 L237.4,194.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4538_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_344_",
    x: 232.3,
    y: 193.8,
    transform: "matrix(0.9284 -0.3717 0.3717 0.9284 -56.6911 100.7289)",
    className: "st1",
    width: 1.2,
    height: 7.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4537_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_343_",
    x: 237.6,
    y: 196.5,
    transform: "matrix(0.9284 -0.3717 0.3717 0.9284 -57.2927 102.8891)",
    className: "st1",
    width: 1.2,
    height: 7.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4536_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_341_",
    x: 245.5,
    y: 193.4,
    transform: "matrix(0.9284 -0.3717 0.3717 0.9284 -55.5792 105.5782)",
    className: "st1",
    width: 1.2,
    height: 7.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4535_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_340_",
    x: 250.4,
    y: 190.1,
    transform: "matrix(0.9284 -0.3717 0.3717 0.9284 -53.9962 107.1715)",
    className: "st1",
    width: 1.2,
    height: 7.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4534_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_333_",
    transform: "matrix(0.9269 -0.3754 0.3754 0.9269 -52.1248 104.0956)",
    className: "st0",
    cx: 241.1,
    cy: 185.8,
    rx: 7.8,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_335_",
    className: "st1",
    d: "M238.3,191.5c-0.4,0-0.8,0-1.2-0.1c-1.9-0.3-3.3-1.1-3.8-2.5c-0.5-1.3-0.2-2.9,1-4.4 c2.3-2.9,7.1-4.9,10.8-4.4c1.9,0.3,3.3,1.1,3.8,2.5c0.5,1.3,0.2,2.9-1,4.4C245.8,189.7,241.8,191.5,238.3,191.5z M243.8,181.4 c-3.1,0-6.7,1.6-8.5,4c-0.9,1.2-1.2,2.3-0.8,3.2c0.4,0.9,1.4,1.5,2.8,1.7c3.3,0.5,7.6-1.3,9.6-3.9c0.9-1.2,1.2-2.3,0.8-3.2 s-1.4-1.5-2.8-1.7l0,0C244.6,181.4,244.2,181.4,243.8,181.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4533_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_328_",
    className: "st0",
    d: "M237,190.4c-0.1,0.1-0.1,0.1-0.2,0.2c0.1,0,0.2,0.2,0.3,0.2c3.5,0.5,8-1.4,10.2-4.1 c0.1-0.1,0-0.3,0.1-0.4c-0.1,0-0.1,0-0.3,0C243.7,185.8,239.2,187.7,237,190.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_329_",
    className: "st1",
    d: "M238.3,191.5c-0.4,0-0.8,0-1.2-0.1c-0.2,0-0.4-0.1-0.5-0.2l-0.8-0.2l0.7-1 c2.3-2.9,7.1-4.9,10.8-4.4c0.1,0,0.2,0,0.2,0l0.9,0.2l-0.4,0.7c0,0.1,0,0.3-0.2,0.5C245.8,189.7,241.8,191.5,238.3,191.5z  M238,190.3c2.9,0.2,6.5-1.3,8.5-3.4C243.5,186.7,240,188.1,238,190.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4541_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4549_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_324_",
    className: "st0",
    d: "M201.1,124.9l-4.4-2.8l-1.3-5.9l1.3-2.1c0,0,0,0,0,0l-4.8-4.1l-10.5-0.6l-4.9-4.7 c-0.1-0.1-0.2,0-0.2,0l-3.7,5.9c0,0,0,0,0,0.1l0,0l-2.4-2c0,0,0,0,0,0l-3.8,6c0,0-0.1,0.2-0.2,0.4l-0.3,2.2 c-0.1,0.8,0.8,1.8,1.9,2.3l1.7,0.7c0.2,0.7,0.5,1.4,0.9,2.2c0.3,0.6,0.7,1.2,1.1,1.7l-0.8,1.3l0,0.1c-0.4,0.5-0.1,1.3,0.8,2 l2.6,2.3c1,0.8,2.3,1.2,3,0.7l1-0.6c1.8,1,3.6,1.9,5.5,2.4l0.7,1.3c0.5,0.9,1.8,1.7,2.8,1.8l2.9,0.1c0.5,0,0.8-0.1,1-0.4 l0.1-0.1l0,0l2.8-4.4l1.3,0.6c1.1,0.5,2,0.3,2.2-0.3L201.1,124.9C201.1,124.9,201.1,124.9,201.1,124.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_325_",
    className: "st1",
    d: "M190,136.2c-0.1,0-0.1,0-0.2,0l-2.9-0.1c-1.3,0-2.7-1-3.3-2.1l-0.6-1.1 c-1.7-0.5-3.4-1.2-5.1-2.2l-0.6,0.4c-0.9,0.6-2.5,0.3-3.7-0.8l-2.6-2.3c-1.1-1-1.5-2.1-0.9-2.9l0.6-1c-0.4-0.5-0.7-1-0.9-1.5 c-0.4-0.7-0.6-1.4-0.9-2l-1.4-0.6c-1.4-0.6-2.4-1.9-2.3-3l0.3-2.2c0-0.2,0.2-0.5,0.2-0.6l3.9-6.3l0.5-0.1l0.2,0.2l1.9,1.6 l3.5-5.6l0.4-0.1c0.2,0,0.5,0,0.6,0.2l4.7,4.6l10.5,0.6l5.1,4.4v0.1l0.1,0.2l-1.3,2.1l1.2,5.4l4.6,3l-0.2,0.5l-3.8,6.1 c-0.1,0.3-0.4,0.6-0.8,0.7c-0.6,0.2-1.4,0.2-2.2-0.2l-0.8-0.3l-2.6,4.1C191.1,136.1,190.5,136.2,190,136.2z M177.9,129.3 l0.3,0.2c1.8,1.1,3.6,1.8,5.4,2.3l0.3,0.1l0.8,1.6c0.4,0.7,1.5,1.4,2.3,1.4l2.9,0.1c0.2,0,0.4,0,0.5-0.1l0.1-0.1l3-4.8 l1.8,0.8c0.6,0.3,1,0.2,1.3,0.2c0.1,0,0.1-0.1,0.2-0.1l3.5-5.6l-4.1-2.6l-1.5-6.5l1.2-1.8l-4.2-3.6l-10.5-0.6l-4.6-4.5l-3.8,6 l-0.6-0.4l-1.9-1.6l-3.4,5.4c0,0-0.1,0.1-0.1,0.2l-0.3,2.1c-0.1,0.4,0.5,1.2,1.6,1.7l1.9,0.8l0.1,0.3c0.2,0.7,0.5,1.4,0.8,2.1 c0.3,0.5,0.6,1,1.1,1.7l0.2,0.3l-1.1,1.8c-0.1,0.1,0.1,0.6,0.7,1.2l2.6,2.3c0.9,0.7,1.9,0.9,2.2,0.7L177.9,129.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4548_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_316_",
    className: "st0",
    d: "M199.5,120.1l-1.7-0.7c-0.2-0.7-0.5-1.4-0.9-2.2c-0.4-0.8-0.9-1.5-1.5-2.2l1-0.6 c0.7-0.4,0.4-1.5-0.5-2.3l-2.6-2.3c-1-0.8-2.3-1.2-3-0.7l-1,0.6c-1.8-1-3.6-1.9-5.5-2.4l-0.7-1.3c-0.5-0.9-1.8-1.7-2.8-1.8 l-2.9-0.1c-1.1,0-1.5,0.7-1,1.6l0.7,1.3c-1.4,0.4-2.5,1.1-3.2,2.1l-1.7-0.7c-1.2-0.5-2.2-0.3-2.3,0.5l-0.3,2.2 c-0.1,0.8,0.8,1.8,1.9,2.3l1.7,0.7c0.2,0.7,0.5,1.4,0.9,2.2c0.4,0.8,0.9,1.5,1.5,2.2l-1,0.6c-0.7,0.4-0.4,1.5,0.5,2.3l2.6,2.3 c1,0.8,2.3,1.2,3,0.7l1-0.6c1.8,1,3.6,1.9,5.5,2.4l0.7,1.3c0.5,0.9,1.8,1.7,2.8,1.8l2.9,0.1c1.1,0,1.5-0.7,1-1.6l-0.7-1.3 c1.4-0.4,2.5-1.1,3.2-2.1l1.7,0.7c1.2,0.5,2.2,0.3,2.3-0.5l0.3-2.2C201.5,121.7,200.6,120.6,199.5,120.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_321_",
    className: "st1",
    d: "M193.8,130.1C193.7,130.1,193.7,130.1,193.8,130.1l-3-0.1c-1.3,0-2.7-1-3.3-2.1l-0.6-1.1 c-1.7-0.5-3.4-1.2-5.1-2.2l-0.6,0.4c-0.9,0.6-2.5,0.3-3.7-0.8l-2.6-2.3c-0.8-0.7-1.2-1.4-1.1-2.2c0-0.5,0.3-0.9,0.7-1.1 l0.4-0.3c-0.4-0.6-0.8-1.2-1.1-1.8c-0.4-0.7-0.6-1.4-0.9-2l-1.4-0.6c-1.5-0.6-2.4-1.9-2.3-3l0.3-2.2c0.1-0.5,0.3-0.9,0.7-1.1 c0.6-0.4,1.5-0.3,2.4,0.1l1.2,0.5c0.6-0.7,1.5-1.3,2.4-1.7l-0.4-0.7c-0.3-0.6-0.4-1.3-0.1-1.8c0.3-0.5,1-0.8,1.6-0.7l2.9,0.1 c1.3,0,2.7,1,3.3,2.1l0.6,1.1c1.7,0.5,3.4,1.2,5.1,2.2l0.6-0.4c0.9-0.6,2.5-0.3,3.7,0.8l2.6,2.3c0.8,0.7,1.2,1.4,1.1,2.2 c0,0.5-0.3,0.9-0.7,1.1l-0.4,0.3c0.4,0.6,0.8,1.2,1.1,1.8c0.4,0.7,0.6,1.4,0.9,2l1.4,0.6c1.4,0.6,2.4,1.9,2.3,3l-0.3,2.2 c-0.1,0.5-0.3,0.8-0.7,1.1c-0.6,0.4-1.5,0.3-2.4-0.1l-1.2-0.5c-0.6,0.7-1.5,1.3-2.4,1.7l0.4,0.7c0.3,0.6,0.4,1.3,0.1,1.8 C195,129.8,194.5,130.1,193.8,130.1z M181.7,123.2l0.3,0.2c1.7,1,3.6,1.8,5.4,2.3l0.3,0.1l0.8,1.6c0.4,0.7,1.5,1.4,2.3,1.4 l2.9,0.1c0.3,0,0.5-0.1,0.5-0.2c0.1-0.1,0.1-0.3-0.1-0.6l-1.1-2l0.7-0.2c1.2-0.3,2.2-1,2.8-1.8l0.3-0.4l2.1,0.9 c0.6,0.3,1.1,0.3,1.3,0.1c0.1,0,0.1-0.1,0.1-0.2l0.3-2.2c0-0.4-0.5-1.3-1.6-1.7l-1.9-0.8l-0.1-0.3c-0.2-0.7-0.5-1.4-0.8-2.1 c-0.4-0.7-0.8-1.4-1.4-2.1l-0.4-0.5l1.5-1c0.1,0,0.1-0.1,0.1-0.2c0-0.3-0.2-0.7-0.7-1.1l-2.6-2.3c-0.8-0.7-1.9-0.9-2.2-0.7 l-1.3,0.8l-0.3-0.2c-1.7-1-3.6-1.8-5.4-2.3l-0.3-0.1l-0.8-1.6c-0.4-0.7-1.5-1.4-2.3-1.4l-2.9-0.1c-0.3,0-0.5,0.1-0.5,0.2 c-0.1,0.1-0.1,0.3,0.1,0.6l1.1,2l-0.7,0.2c-1.2,0.3-2.2,1-2.8,1.8l-0.3,0.4L172,109c-0.6-0.3-1.1-0.3-1.3-0.1 c-0.1,0-0.1,0.1-0.1,0.2l-0.3,2.2c-0.1,0.4,0.5,1.3,1.6,1.7l1.9,0.8l0.1,0.3c0.2,0.7,0.5,1.4,0.8,2.1c0.4,0.7,0.8,1.4,1.4,2.1 l0.4,0.5l-1.5,1c-0.1,0-0.1,0.1-0.1,0.2c0,0.3,0.2,0.7,0.7,1.1l2.6,2.3c0.8,0.7,1.9,0.9,2.2,0.7L181.7,123.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4547_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_320_",
    className: "st1",
    points: "170,120.4 168.9,119.8 172.7,113.7 173.8,114.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4546_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_319_",
    x: 168.8,
    y: 122.3,
    transform: "matrix(0.5295 -0.8483 0.8483 0.5295 -23.1635 204.0308)",
    className: "st1",
    width: 7.2,
    height: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4545_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_318_",
    x: 175.9,
    y: 126.8,
    transform: "matrix(0.5295 -0.8483 0.8483 0.5295 -23.6265 212.1887)",
    className: "st1",
    width: 7.2,
    height: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4544_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_317_",
    x: 181.5,
    y: 128.8,
    transform: "matrix(0.5295 -0.8483 0.8483 0.5295 -22.7172 217.8774)",
    className: "st1",
    width: 7.2,
    height: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4543_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_310_",
    className: "st0",
    d: "M191.9,117c1.7,3.1,0.2,5.5-3.4,5.4c-3.5-0.1-7.7-2.7-9.4-5.8c-1.7-3.1-0.2-5.5,3.4-5.4 C186,111.3,190.2,113.9,191.9,117z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_313_",
    className: "st1",
    d: "M188.8,123c-0.1,0-0.2,0-0.3,0c-3.7-0.1-8.1-2.9-9.9-6.1c-0.9-1.7-1-3.3-0.2-4.5 c0.8-1.2,2.2-1.8,4.2-1.8c3.7,0.1,8.1,2.9,9.9,6.1c0.9,1.7,1,3.3,0.2,4.5C192,122.4,190.6,123,188.8,123z M182.3,111.8 c-1.4,0-2.4,0.4-2.9,1.2c-0.5,0.8-0.4,2,0.3,3.3c1.6,2.9,5.5,5.4,8.8,5.5c1.4,0.1,2.6-0.4,3.1-1.2c0.5-0.8,0.4-2-0.3-3.3 c-1.6-2.9-5.5-5.4-8.8-5.5C182.4,111.8,182.4,111.8,182.3,111.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4542_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_304_",
    className: "st0",
    d: "M179.4,116.2c-0.1,0-0.1,0-0.3,0c0.1,0.1,0,0.2,0,0.4c1.7,3.1,5.8,5.7,9.4,5.8 c0.1,0,0.2-0.1,0.4-0.1c-0.1-0.1-0.1-0.1-0.1-0.2C187.1,118.9,182.9,116.3,179.4,116.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_305_",
    className: "st1",
    d: "M188.5,123C188.5,123,188.5,123,188.5,123c-3.7-0.1-8.2-2.9-9.9-6.1 c-0.1-0.2-0.1-0.4-0.1-0.5l-0.4-0.8l1,0c0.2,0,0.2,0,0.3,0c3.7,0.1,8.1,2.9,9.9,6.1c0.1,0.1,0.1,0.1,0.1,0.2l0.4,0.9l-0.8,0.1 C188.9,122.9,188.8,123,188.5,123z M180.1,116.9c1.6,2.5,4.9,4.5,7.8,4.8C186.3,119.3,183,117.3,180.1,116.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4451_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4455_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_297_",
    className: "st0",
    d: "M264.9,88.6c0.6,1.5-0.8,3.4-3,4.2s-4.5,0.2-5-1.3c-0.6-1.5,0.8-3.4,3-4.2 C262.1,86.5,264.4,87.1,264.9,88.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_299_",
    className: "st1",
    d: "M259.9,93.9c-1.7,0-3.1-0.8-3.6-2.1c-0.7-1.9,0.8-4.1,3.4-5c2.6-0.9,5.1-0.2,5.8,1.7v0 c0.7,1.9-0.8,4.1-3.4,5C261.4,93.7,260.6,93.9,259.9,93.9z M261.8,87.6c-0.6,0-1.1,0.1-1.7,0.3c-1.9,0.7-3.1,2.3-2.6,3.5 c0.4,1.2,2.4,1.6,4.2,1c1.9-0.7,3.1-2.3,2.6-3.5C264,88,263,87.6,261.8,87.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4454_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_290_",
    className: "st0",
    d: "M275.6,77.3c0.6,1.5-0.8,3.4-3,4.2c-2.2,0.8-4.5,0.2-5-1.3c-0.6-1.5,0.8-3.4,3-4.2 S275.1,75.8,275.6,77.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_293_",
    className: "st1",
    d: "M270.7,82.5c-0.5,0-0.9-0.1-1.3-0.2c-1.1-0.3-2-1-2.3-1.9c-0.3-0.9-0.2-2,0.5-3 c0.6-0.9,1.6-1.6,2.8-2.1c1.2-0.4,2.4-0.5,3.5-0.2c1.2,0.3,2,1,2.3,1.9l0,0c0.3,0.9,0.2,2-0.5,3c-0.6,0.9-1.6,1.6-2.8,2.1 C272.1,82.4,271.4,82.5,270.7,82.5z M272.6,76.2c-0.6,0-1.2,0.1-1.7,0.3c-1,0.3-1.7,0.9-2.2,1.6c-0.4,0.6-0.6,1.3-0.4,1.8 c0.2,0.6,0.7,1,1.5,1.2c0.8,0.2,1.8,0.2,2.8-0.2c1-0.3,1.7-0.9,2.2-1.6c0.4-0.6,0.6-1.3,0.4-1.8v0c-0.2-0.6-0.7-1-1.5-1.2 C273.3,76.3,272.9,76.2,272.6,76.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4453_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_292_",
    className: "st1",
    d: "M264.3,88.8l-6.7-18.4c-0.3-0.8-0.1-1.8,0.5-2.4l9.2-9.2c0.4-0.4,0.9-0.5,1.4-0.4 c0.5,0.1,0.9,0.5,1.1,0.9l6.4,17.7l-1.2,0.4l-6.4-17.7c0-0.1-0.1-0.1-0.2-0.1c0,0-0.1,0-0.2,0.1l-9.2,9.2 c-0.3,0.3-0.4,0.7-0.2,1.1l6.7,18.4L264.3,88.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4452_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_283_",
    className: "st0",
    d: "M260.7,73.9l9.3-9.1c0.5-0.5,0.6-1.2,0.4-1.8l-1.2-3.4c-0.2-0.6-0.9-0.7-1.4-0.3 l-9.2,9.2c-0.5,0.4-0.6,1.1-0.4,1.7l1.2,3.4C259.6,74.1,260.3,74.2,260.7,73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_284_",
    className: "st1",
    d: "M260.2,74.7c-0.1,0-0.2,0-0.3,0c-0.5-0.1-0.8-0.4-1-0.9l-1.2-3.4 c-0.3-0.8-0.1-1.8,0.5-2.4l9.2-9.2c0.4-0.4,0.9-0.5,1.4-0.4c0.5,0.1,0.9,0.5,1.1,0.9l1.2,3.4c0.3,0.9,0.1,1.8-0.6,2.5 l-9.3,9.1C260.9,74.6,260.5,74.7,260.2,74.7z M268.4,59.7c0,0-0.1,0-0.2,0.1l-9.2,9.2c-0.3,0.3-0.4,0.7-0.2,1.1l1.2,3.4 l0.2,0.1l9.3-9.1c0.3-0.3,0.4-0.8,0.3-1.2l-1.2-3.4C268.6,59.7,268.5,59.7,268.4,59.7C268.5,59.7,268.4,59.7,268.4,59.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4446_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4450_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_276_",
    className: "st0",
    d: "M137.1,144.8c-0.7,1.5-3,1.8-5.1,0.8c-2.1-1-3.3-3.1-2.5-4.5c0.7-1.5,3-1.8,5.1-0.8 C136.7,141.3,137.8,143.4,137.1,144.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_278_",
    className: "st1",
    d: "M135.3,146.8c0,0-0.1,0-0.1,0c-1.1,0.2-2.3,0-3.5-0.6c-1.1-0.5-2.1-1.4-2.6-2.4 c-0.6-1-0.7-2.1-0.2-3c0.4-0.9,1.3-1.5,2.5-1.7c1.1-0.2,2.3,0,3.5,0.6c1.1,0.5,2.1,1.4,2.6,2.4c0.6,1,0.7,2.1,0.2,3 C137.2,146,136.4,146.6,135.3,146.8z M131.5,140.4c-0.7,0.1-1.2,0.5-1.5,1c-0.3,0.5-0.2,1.2,0.2,1.9c0.4,0.7,1.2,1.4,2.1,1.8 c0.9,0.4,1.9,0.6,2.7,0.5c0.8-0.1,1.3-0.5,1.6-1l0,0c0.3-0.5,0.2-1.2-0.2-1.9c-0.4-0.7-1.2-1.4-2.1-1.8 C133.4,140.4,132.4,140.3,131.5,140.4C131.5,140.4,131.5,140.4,131.5,140.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4447_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_270_",
    className: "st0",
    d: "M141.4,136c0,0,2.3-2.3,7.9,0.6c5.5,2.9,8.3,0.6,8.3,0.6l2.2-4.6 c0.1-0.3-0.1-0.6-0.4-0.5c-1.6,0.5-5.1,1.3-8.1-0.8c-3.4-2.4-6.9-1.2-7.2-0.6l-6.8,14.1L141.4,136z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_271_",
    className: "st1",
    d: "M137.7,145.1l-1.1-0.5l6.8-14.1c0.3-0.5,1.2-0.8,1.7-1c0.8-0.2,3.6-0.7,6.5,1.4 c2.8,2,6.2,1.2,7.6,0.7c0.4-0.1,0.8,0,1,0.3c0.3,0.3,0.3,0.7,0.1,1.1l-2.4,4.8c-0.1,0.1-3.1,2.5-8.9-0.6 c-4.6-2.4-6.7-1.1-7.1-0.8L137.7,145.1z M143,134.7c1.4-0.3,3.5-0.1,6.5,1.4c4.6,2.3,7,1.1,7.5,0.8l1.9-3.9 c-1.8,0.5-5.2,1-8.1-1.1c-3-2.2-6-1.1-6.3-0.8l-1.8,3.7C142.8,134.7,142.9,134.7,143,134.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4551_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4550_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_228_",
    className: "st0",
    d: "M201.1,235.1l-19.3-12.7c-1.1-0.8-1.5-2.3-0.7-3.4l6.4-9.7c0.8-1.1,2.3-1.5,3.4-0.7 l19.3,12.7c1.1,0.8,1.5,2.3,0.7,3.4l-6.4,9.7C203.8,235.6,202.3,235.9,201.1,235.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_243_",
    className: "st1",
    d: "M202.5,236.2c-0.6,0-1.2-0.2-1.7-0.5h0L181.4,223c-1.4-0.9-1.8-2.9-0.9-4.3l6.4-9.7 c0.5-0.7,1.2-1.2,2-1.3c0.8-0.2,1.6,0,2.3,0.4l19.3,12.7c1.4,0.9,1.8,2.9,0.9,4.3l-6.4,9.7c-0.5,0.7-1.2,1.2-2,1.3 C202.9,236.1,202.7,236.2,202.5,236.2z M201.5,234.6c0.4,0.3,0.9,0.4,1.4,0.3c0.5-0.1,0.9-0.4,1.2-0.8l6.4-9.7 c0.6-0.9,0.3-2-0.5-2.6l-19.3-12.7c-0.4-0.3-0.9-0.4-1.4-0.3c-0.5,0.1-0.9,0.4-1.2,0.8l-6.4,9.7c-0.6,0.9-0.3,2,0.5,2.6 L201.5,234.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4552_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_236_",
    className: "st1",
    d: "M207.2,224.8l-1-0.6l0.7-1l1,0.6L207.2,224.8z M203.4,222.4l-2.8-1.8l0.7-1l2.8,1.8 L203.4,222.4z M197.9,218.7l-2.8-1.8l0.7-1l2.8,1.8L197.9,218.7z M192.3,215.1l-2.8-1.8l0.7-1l2.8,1.8L192.3,215.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4553_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_229_",
    className: "st1",
    d: "M202.5,231.9l-1-0.6l0.7-1l1,0.6L202.5,231.9z M198.8,229.4l-2.8-1.8l0.7-1l2.8,1.8 L198.8,229.4z M193.2,225.8l-2.8-1.8l0.7-1l2.8,1.8L193.2,225.8z M187.7,222.2l-2.8-1.8l0.7-1l2.8,1.8L187.7,222.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4555_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4558_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_206_",
    className: "st0",
    d: "M306.3,115.6l-22.9-3.3c-1.4-0.2-2.3-1.4-2.1-2.8l1.6-11.5c0.2-1.4,1.4-2.3,2.8-2.1 l22.9,3.3c1.4,0.2,2.3,1.4,2.1,2.8l-1.6,11.5C308.9,114.9,307.7,115.8,306.3,115.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_223_",
    className: "st1",
    d: "M306.6,116.3c-0.1,0-0.3,0-0.4,0l-22.9-3.3c-0.8-0.1-1.5-0.5-2-1.2 c-0.5-0.7-0.7-1.5-0.6-2.3l1.6-11.5c0.1-0.8,0.5-1.5,1.2-2c0.7-0.5,1.5-0.7,2.3-0.6l22.9,3.3c1.7,0.2,2.9,1.8,2.6,3.5 l-1.6,11.5C309.5,115.1,308.2,116.3,306.6,116.3z M306.4,115c1,0.1,2-0.6,2.1-1.6l1.6-11.5c0.1-1-0.6-2-1.6-2.1l-22.9-3.3 c-0.5-0.1-1,0.1-1.4,0.4c-0.4,0.3-0.7,0.7-0.7,1.2l-1.6,11.5c-0.1,0.5,0.1,1,0.4,1.4c0.3,0.4,0.7,0.7,1.2,0.7L306.4,115z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4557_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_217_",
    className: "st1",
    d: "M307.4,103.7l-1.2-0.2l0.2-1.2l1.2,0.2L307.4,103.7z M303,103.1l-3.3-0.5l0.2-1.2 l3.3,0.5L303,103.1z M296.4,102.1l-3.3-0.5l0.2-1.2l3.3,0.5L296.4,102.1z M289.8,101.2l-3.3-0.5l0.2-1.2l3.3,0.5L289.8,101.2z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4556_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_207_",
    className: "st1",
    d: "M306.2,112.1l-1.2-0.2l0.2-1.2l1.2,0.2L306.2,112.1z M301.8,111.4l-3.3-0.5l0.2-1.2 l3.3,0.5L301.8,111.4z M295.2,110.5l-3.3-0.5l0.2-1.2l3.3,0.5L295.2,110.5z M288.6,109.6l-3.3-0.5l0.2-1.2l3.3,0.5 L288.6,109.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4559_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4562_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_185_",
    className: "st0",
    d: "M170.7,92.8l-17.4-15.2c-1-0.9-1.1-2.5-0.2-3.5l7.6-8.7c0.9-1,2.5-1.1,3.5-0.2l17.4,15.2 c1,0.9,1.1,2.5,0.2,3.5l-7.6,8.7C173.3,93.6,171.8,93.7,170.7,92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_202_",
    className: "st1",
    d: "M172.4,94.1c-0.7,0-1.5-0.3-2-0.8l-17.4-15.2c-0.6-0.5-1-1.3-1.1-2.1 c-0.1-0.8,0.2-1.6,0.8-2.3l7.6-8.7c1.1-1.3,3.1-1.4,4.4-0.3L182,79.9c0.6,0.5,1,1.3,1.1,2.1c0.1,0.8-0.2,1.6-0.8,2.3l-7.6,8.7 c-0.5,0.6-1.3,1-2.1,1.1C172.5,94.1,172.4,94.1,172.4,94.1z M171.1,92.4c0.4,0.3,0.9,0.5,1.3,0.5c0.5,0,0.9-0.3,1.3-0.6 l7.6-8.7c0.3-0.4,0.5-0.9,0.5-1.3c0-0.5-0.3-0.9-0.6-1.3l-17.4-15.2c-0.8-0.7-2-0.6-2.6,0.2l-7.6,8.7 c-0.3,0.4-0.5,0.9-0.5,1.3c0,0.5,0.3,0.9,0.6,1.3L171.1,92.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4561_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_194_",
    className: "st1",
    d: "M178.1,83.4l-0.9-0.8l0.8-0.9l0.9,0.8L178.1,83.4z M174.8,80.5l-2.5-2.2l0.8-0.9l2.5,2.2 L174.8,80.5z M169.8,76.1l-2.5-2.2l0.8-0.9l2.5,2.2L169.8,76.1z M164.8,71.8l-2.5-2.2l0.8-0.9l2.5,2.2L164.8,71.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4560_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_187_",
    className: "st1",
    d: "M172.6,89.8l-0.9-0.8l0.8-0.9l0.9,0.8L172.6,89.8z M169.2,86.9l-2.5-2.2l0.8-0.9l2.5,2.2 L169.2,86.9z M164.2,82.5l-2.5-2.2l0.8-0.9l2.5,2.2L164.2,82.5z M159.2,78.2l-2.5-2.2l0.8-0.9l2.5,2.2L159.2,78.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4564_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_179_",
    className: "st0",
    d: "M234.8,216.3l0.3,2.6c0,0.4,0.3,0.7,0.6,0.9l2.3,1.3c0.8,0.5,0.8,1.7-0.1,2.1l-2.4,1 c-0.3,0.2-0.6,0.5-0.7,0.8l-0.5,2.6c-0.2,0.9-1.4,1.3-2,0.5l-1.7-1.9c-0.2-0.3-0.6-0.4-1-0.4L227,226c-0.9,0.1-1.6-0.9-1.1-1.7 l1.3-2.2c0.2-0.3,0.2-0.7,0.1-1.1l-1.1-2.4c-0.4-0.9,0.4-1.8,1.3-1.6l2.5,0.6c0.4,0.1,0.8,0,1-0.3l1.9-1.8 C233.6,214.9,234.8,215.3,234.8,216.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_181_",
    className: "st1",
    d: "M233.2,229c-0.5,0-1-0.2-1.3-0.6l-1.7-1.9c-0.1-0.1-0.3-0.2-0.5-0.2l-2.6,0.3 c-0.7,0.1-1.3-0.2-1.7-0.8c-0.4-0.6-0.4-1.3,0-1.9l1.3-2.2c0.1-0.1,0.1-0.3,0-0.5l-1.1-2.4c-0.3-0.6-0.2-1.3,0.2-1.9 c0.4-0.5,1.1-0.8,1.8-0.6l2.5,0.6c0.2,0,0.3,0,0.5-0.1l1.9-1.8c0.5-0.5,1.2-0.6,1.8-0.4c0.6,0.2,1.1,0.8,1.1,1.5l0.3,2.6 c0,0.2,0.1,0.3,0.3,0.4l2.3,1.3c0.6,0.3,0.9,1,0.9,1.6c0,0.7-0.4,1.3-1.1,1.5l-2.4,1c-0.2,0.1-0.3,0.2-0.3,0.4l-0.5,2.6 c-0.1,0.7-0.6,1.2-1.3,1.4C233.5,229,233.3,229,233.2,229z M229.7,225.1c0.5,0,1,0.2,1.3,0.6l1.7,1.9c0.2,0.2,0.4,0.2,0.5,0.2 c0.1,0,0.3-0.1,0.4-0.4l0.5-2.6c0.1-0.6,0.5-1,1-1.3l2.4-1c0.3-0.1,0.3-0.4,0.3-0.5c0-0.1,0-0.3-0.3-0.5l-2.3-1.3 c-0.5-0.3-0.8-0.8-0.9-1.4l-0.3-2.6c0-0.3-0.2-0.4-0.3-0.4c-0.1,0-0.3-0.1-0.5,0.1l-1.9,1.8c-0.4,0.4-1,0.6-1.6,0.4l-2.5-0.6 c-0.3-0.1-0.5,0.1-0.5,0.2c-0.1,0.1-0.2,0.3-0.1,0.5l1.1,2.4c0.2,0.5,0.2,1.1-0.1,1.6l-1.3,2.2c-0.1,0.3,0,0.5,0,0.6 c0.1,0.1,0.2,0.3,0.5,0.2l2.6-0.3C229.6,225.1,229.7,225.1,229.7,225.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4565_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_174_",
    className: "st0",
    d: "M150.3,101.7l2.2,1.4c0.3,0.2,0.7,0.2,1.1,0.1l2.4-1c0.9-0.4,1.8,0.4,1.5,1.4l-0.7,2.5 c-0.1,0.4,0,0.8,0.2,1l1.7,2c0.6,0.7,0.1,1.8-0.8,1.9l-2.6,0.1c-0.4,0-0.7,0.2-0.9,0.5l-1.4,2.2c-0.5,0.8-1.7,0.7-2-0.2 l-0.9-2.4c-0.1-0.4-0.4-0.6-0.8-0.7l-2.5-0.6c-0.9-0.2-1.2-1.4-0.5-2l2-1.6c0.3-0.2,0.5-0.6,0.4-1l-0.2-2.6 C148.5,101.8,149.5,101.2,150.3,101.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_175_",
    className: "st1",
    d: "M152.1,115.1c-0.1,0-0.1,0-0.2,0c-0.7-0.1-1.2-0.5-1.5-1.1l-0.9-2.4 c-0.1-0.2-0.2-0.3-0.4-0.3l-2.5-0.6c-0.7-0.2-1.2-0.7-1.3-1.3c-0.1-0.7,0.1-1.3,0.6-1.8l2-1.6c0.1-0.1,0.2-0.3,0.2-0.4 l-0.2-2.6c-0.1-0.7,0.3-1.3,0.9-1.7c0.6-0.3,1.3-0.3,1.9,0l2.2,1.4c0.1,0.1,0.3,0.1,0.5,0l2.4-1c0.6-0.3,1.3-0.1,1.8,0.3 c0.5,0.4,0.7,1.1,0.5,1.8l-0.7,2.5c0,0.2,0,0.3,0.1,0.5l1.7,2c0.4,0.5,0.5,1.2,0.3,1.8c-0.3,0.6-0.9,1-1.5,1.1l-2.6,0.1 c-0.2,0-0.3,0.1-0.4,0.2l-1.4,2.2C153.3,114.8,152.7,115.1,152.1,115.1z M149.7,102.1c-0.1,0-0.2,0-0.3,0.1 c-0.1,0.1-0.3,0.2-0.3,0.5l0.2,2.6c0,0.6-0.2,1.1-0.7,1.5l-2,1.6c-0.2,0.2-0.2,0.4-0.2,0.5c0,0.1,0.1,0.3,0.4,0.4l2.5,0.6 c0.6,0.1,1,0.5,1.2,1.1l0.9,2.4c0.1,0.3,0.3,0.3,0.4,0.3c0.1,0,0.3,0,0.5-0.2l1.4-2.2c0.3-0.5,0.8-0.8,1.4-0.8l2.6-0.1 c0.3,0,0.4-0.2,0.5-0.3c0-0.1,0.1-0.3-0.1-0.5l-1.7-2c-0.4-0.4-0.5-1-0.4-1.6l0.7-2.5c0.1-0.3-0.1-0.5-0.2-0.5 c-0.1-0.1-0.3-0.2-0.5-0.1l-2.4,1c-0.5,0.2-1.1,0.2-1.6-0.2l-2.2-1.4C149.9,102.2,149.8,102.1,149.7,102.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4566_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_168_",
    className: "st0",
    d: "M238,66.5l0.6,2.5c0.1,0.4,0.3,0.7,0.7,0.8l2.4,0.9c0.9,0.3,1,1.6,0.2,2l-2.2,1.4 c-0.3,0.2-0.5,0.5-0.5,0.9l-0.1,2.6c-0.1,0.9-1.2,1.4-1.9,0.8l-2-1.7c-0.3-0.2-0.7-0.3-1-0.2l-2.5,0.7 c-0.9,0.2-1.7-0.7-1.4-1.5l1-2.4c0.1-0.3,0.1-0.7-0.1-1.1l-1.4-2.2c-0.5-0.8,0.1-1.8,1.1-1.8l2.6,0.2c0.4,0,0.7-0.1,1-0.4 l1.6-2C236.5,65.3,237.7,65.6,238,66.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_169_",
    className: "st1",
    d: "M237.8,79.4c-0.4,0-0.8-0.1-1.1-0.4l-2-1.7c-0.1-0.1-0.3-0.2-0.5-0.1l-2.5,0.7 c-0.7,0.2-1.3,0-1.8-0.5c-0.4-0.5-0.6-1.2-0.3-1.8l1-2.4c0.1-0.2,0.1-0.3,0-0.5l-1.4-2.2c-0.4-0.6-0.4-1.3,0-1.9 c0.3-0.6,1-0.9,1.7-0.9l2.6,0.2c0.2,0,0.3-0.1,0.4-0.2l1.6-2c0.4-0.5,1.1-0.8,1.8-0.6c0.7,0.2,1.2,0.7,1.3,1.3l0.6,2.5 c0,0.2,0.2,0.3,0.3,0.4l2.4,0.9c0.6,0.2,1.1,0.8,1.1,1.5c0.1,0.7-0.3,1.3-0.8,1.7l-2.2,1.4c-0.1,0.1-0.2,0.2-0.2,0.4l-0.1,2.6 c0,0.7-0.4,1.3-1.1,1.5C238.3,79.3,238,79.4,237.8,79.4z M234.4,75.9c0.4,0,0.8,0.1,1.1,0.4l2,1.7c0.2,0.2,0.5,0.1,0.5,0.1 c0.1,0,0.3-0.2,0.3-0.5l0.1-2.6c0-0.6,0.3-1.1,0.8-1.4l2.2-1.4c0.3-0.2,0.3-0.4,0.2-0.5c0-0.1-0.1-0.3-0.3-0.4l-2.4-0.9 c-0.5-0.2-0.9-0.7-1.1-1.2l-0.6-2.5c-0.1-0.3-0.3-0.4-0.4-0.4c-0.1,0-0.3,0-0.5,0.2l-1.6,2c-0.4,0.5-0.9,0.7-1.5,0.6l-2.6-0.2 c-0.3,0-0.4,0.2-0.5,0.3c-0.1,0.1-0.1,0.3,0,0.6l1.4,2.2c0.3,0.5,0.4,1.1,0.2,1.6l-1,2.4c-0.1,0.3,0,0.5,0.1,0.5 c0.1,0.1,0.2,0.2,0.5,0.2l2.5-0.7C234,75.9,234.2,75.9,234.4,75.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1213_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_162_",
    className: "st0",
    d: "M171,48.9l-1.8,0.7c-0.3,0.1-0.5,0.3-0.5,0.6l-0.5,1.8c-0.2,0.7-1,0.9-1.5,0.3l-1.2-1.5 c-0.2-0.2-0.4-0.3-0.7-0.3l-1.9,0.1c-0.7,0-1.1-0.7-0.7-1.3l1.1-1.6c0.2-0.2,0.2-0.5,0.1-0.8l-0.7-1.8c-0.3-0.6,0.3-1.3,1-1.1 l1.8,0.5c0.3,0.1,0.6,0,0.8-0.2l1.5-1.2c0.5-0.4,1.3-0.1,1.4,0.6l0.1,1.9c0,0.3,0.2,0.5,0.4,0.7l1.6,1 C171.8,47.8,171.7,48.7,171,48.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_164_",
    className: "st1",
    d: "M167.4,53.2c-0.4,0-0.9-0.2-1.1-0.6l-1.2-1.5c0-0.1-0.1-0.1-0.2-0.1l-1.9,0.1 c-0.6,0-1.1-0.2-1.4-0.7c-0.3-0.5-0.3-1.1,0.1-1.5l1.1-1.6c0-0.1,0-0.1,0-0.2l-0.7-1.8c-0.2-0.5-0.1-1.1,0.3-1.5 c0.4-0.4,1-0.6,1.5-0.4l1.8,0.5c0.1,0,0.1,0,0.2,0l1.5-1.2c0.4-0.4,1-0.4,1.5-0.2c0.5,0.2,0.8,0.7,0.9,1.3l0.1,1.9 c0,0.1,0,0.1,0.1,0.2l1.6,1c0.5,0.3,0.7,0.8,0.7,1.4c-0.1,0.6-0.4,1-1,1.2l-1.8,0.7c-0.1,0-0.1,0.1-0.1,0.1l-0.5,1.8 c-0.1,0.5-0.6,1-1.1,1.1C167.6,53.2,167.5,53.2,167.4,53.2z M164.9,49.8c0.4,0,0.9,0.2,1.2,0.6l1.2,1.5 c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.1,0,0.2-0.2l0.5-1.8c0.1-0.5,0.5-0.8,0.9-1l1.8-0.7c0.1,0,0.1-0.1,0.1-0.2 c0-0.1,0-0.1-0.1-0.2l-1.6-1c-0.4-0.3-0.7-0.7-0.7-1.2l-0.1-1.9c0-0.1-0.1-0.2-0.1-0.2c0,0-0.1,0-0.2,0l-1.5,1.2 c-0.4,0.3-0.9,0.4-1.3,0.3l-1.8-0.5c-0.1,0-0.2,0-0.2,0.1c0,0-0.1,0.1,0,0.2l0.7,1.8c0.2,0.4,0.1,1-0.2,1.4l-1.1,1.6 c-0.1,0.1,0,0.2,0,0.2c0,0,0.1,0.1,0.2,0.1L164.9,49.8C164.8,49.8,164.9,49.8,164.9,49.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4569_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4584_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_157_",
    className: "st0",
    d: "M212.8,59L194.7,42c-1.4-1.3-2.8-1.6-3.6-1l-0.2,0.2L186,45c-0.1,0-0.1,0.1,0,0.2 l3.2,5.6l1.3,2.3l1-1.4l1.5,11.4c0.3,2.6,3.2,5.3,5.1,4.9l7.6-1.5c0,0,0.1,0,0.1,0l3.4,2.1c0.1,0,0.1,0,0.2,0l4.9-4 C215.5,63.7,214.9,60.9,212.8,59z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_158_",
    className: "st1",
    d: "M209.3,69.2c-0.1,0-0.3,0-0.4-0.1l-3.2-2l-7.4,1.5c-0.9,0.2-1.9-0.1-2.9-0.8 c-1.6-1.1-2.7-2.9-2.9-4.6l-1.3-9.8l-0.6,0.9l-1.8-3.2l-3.2-5.6c-0.2-0.3-0.1-0.7,0.2-1l5.1-4.1c1.2-0.8,2.9-0.3,4.4,1.1 l18.1,16.9c1.4,1.4,2.3,3.2,2.3,4.8c0,0.8-0.3,1.5-0.9,1.9l-4.9,3.9C209.6,69.2,209.5,69.2,209.3,69.2z M205.8,65.8l0.3,0.1 l3.1,1.9l4.6-3.7c0.3-0.2,0.4-0.6,0.4-0.9c0-1-0.5-2.5-1.9-3.8l-18.1-16.9c-1.2-1.1-2.3-1.3-2.9-1l-0.2,0.1l-4.5,3.6l3.8,6.7 l1.3-1.9l1.7,12.9c0.2,1.3,1.1,2.9,2.4,3.8c0.7,0.5,1.4,0.7,2,0.6L205.8,65.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4583_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_151_",
    className: "st0",
    d: "M207.6,54.1L194.7,42c-1.4-1.3-2.8-1.6-3.6-1l-0.2,0.2L186,45c-0.1,0-0.1,0.1,0,0.2 l3.2,5.6l1.3,2.3l1-1.4l0.7,5c0.1,0,0.2,0,0.3,0l-0.2,0.7l0.8,5.7c0.1,0.7,0.4,1.5,0.8,2.2L207.6,54.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_152_",
    className: "st1",
    d: "M193.7,66.2l-0.4-0.6c-0.5-0.8-0.8-1.6-0.9-2.4l-1.3-9.8l-0.6,0.9l-1.8-3.2l-3.2-5.6 c-0.2-0.3-0.1-0.7,0.2-1l5.1-4.1c1.2-0.8,2.9-0.3,4.4,1.1l13.5,12.6L193.7,66.2z M192.9,57.4l0.7,5.6c0.1,0.4,0.2,0.9,0.4,1.3 l12.6-10.2l-12.4-11.6c-1.2-1.1-2.3-1.3-2.9-1l-0.2,0.1l-4.5,3.6l3.8,6.7l1.3-1.9l0.8,6l0.7-0.1L192.9,57.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4581_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_145_",
    className: "st0",
    d: "M185.3,47.2l2.7,20c0.3,2.6,3.2,5.3,5.1,4.9l15.5-3.1c2-0.4,1.6-3.8-0.8-6l-18.1-16.9 C187.3,44,185,44.6,185.3,47.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_147_",
    className: "st1",
    d: "M192.7,72.8c-0.8,0-1.6-0.3-2.4-0.9c-1.6-1.1-2.7-2.9-2.9-4.6l-2.7-20 c-0.2-1.3,0.2-2.3,1.2-2.8c1.1-0.6,2.8-0.1,4.2,1.2l18.1,16.9c1.7,1.6,2.6,3.9,2.1,5.5c-0.2,0.8-0.8,1.4-1.7,1.6l-15.5,3.1 C193,72.8,192.9,72.8,192.7,72.8z M185.9,47.1l2.7,20c0.2,1.3,1.1,2.9,2.4,3.8c0.7,0.5,1.4,0.7,2,0.6l15.5-3.1 c0.4-0.1,0.6-0.3,0.7-0.7c0.3-1-0.3-2.8-1.8-4.2l-18.1-16.9c-1.2-1.1-2.2-1.3-2.8-1C185.8,45.9,185.9,46.7,185.9,47.1 L185.9,47.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4580_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_146_",
    x: 188.9,
    y: 43.5,
    transform: "matrix(0.7763 -0.6304 0.6304 0.7763 15.1963 130.9954)",
    className: "st1",
    width: 6.5,
    height: 1.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4579_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4590_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_140_",
    className: "st0",
    d: "M140.1,93.4l0.3-1.6c0.4-1.9-0.2-4.3-1.3-5.8l-1.2-1.5c-1-1.3-2-2.6-3.1-3.8l0.4-1.7 c0.4-1.9-0.2-4.3-1.5-5.7l-2.2-2.4c-0.6-0.7-1.3-1-1.9-0.9l0,0l-3.7,0.8c-1.1-1.1-2.1-2.2-3.2-3.2l-4.2-4 c-0.6-0.6-1.2-0.8-1.8-0.8c-6.4,0.2-11.5,4.2-11.5,4.2l1-0.9l5.1,5l1.2-0.4c-0.9,2.8-1.7,5.7-2.4,8.8l-0.3,1.4 c-0.4,1.9,0.2,4.4,1.5,5.7l15.4,16.9c-1.2,1.2-2.4,2.2-2.5,2.2c-0.2,0-1.7,6.3-1.7,6.3s6.6,0.4,11.5-2.2 c0.1,0,0.1-0.1,0.2-0.1l0,0c0.4-0.2,0.7-0.6,0.9-1.1l0.5-1.2C137.6,103.1,139.1,98.5,140.1,93.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_141_",
    className: "st1",
    d: "M123.6,112.6c-0.6,0-1,0-1,0l-0.7,0l0.2-0.7c1.4-5.9,1.6-6.6,2.1-6.7 c0.2-0.1,0.6-0.5,1.8-1.7l-15-16.4c-1.4-1.5-2.1-4.2-1.6-6.3l0.3-1.4c0.6-2.6,1.2-5.2,2-7.6l-0.3,0.1l-4.9-4.8 c-0.4,0.3-0.7,0.5-0.7,0.5l-0.8-0.9l1.4-1.4l0.2,0.2c2-1.2,5.8-3.1,10.2-3.3c0.7-0.1,1.6,0.2,2.3,0.9l4.2,4c1,1,2,1.9,3,3 l3.4-0.7c0.7-0.1,1.5,0.1,2.5,1.1l2.2,2.4c1.4,1.5,2,4.1,1.6,6.2l-0.3,1.4c1,1.2,1.9,2.4,2.9,3.6l1.2,1.5 c1.3,1.6,1.9,4.2,1.5,6.3l-0.3,1.6c-1.1,5.1-2.6,9.9-4.5,14.1l-0.5,1.2c-0.3,0.6-0.7,1.1-1.2,1.4c-0.1,0-0.1,0.1-0.2,0.1 C130.5,112.4,125.7,112.6,123.6,112.6z M123.4,111.4c1.8,0.1,6.6-0.2,10.4-2.2l0.4,0.5l-0.3-0.6c0.3-0.1,0.5-0.4,0.7-0.8 l0.5-1.2c1.9-4.2,3.3-8.8,4.4-13.9l0.3-1.6c0.4-1.7-0.1-3.9-1.2-5.3l-1.2-1.5c-1-1.3-2-2.6-3.1-3.8l-0.2-0.2l0.4-2 c0.4-1.7-0.2-3.9-1.3-5.1l-2.2-2.4c-0.3-0.4-0.8-0.8-1.3-0.7l-4,0.8l-0.2-0.2c-1.1-1.1-2.1-2.1-3.2-3.2l-4.2-4 c-0.4-0.4-0.9-0.6-1.3-0.6c-4,0.1-7.4,1.8-9.4,2.9l4.1,4l2-0.8l-0.4,1.3c-0.9,2.8-1.7,5.7-2.4,8.7l-0.3,1.4 c-0.4,1.7,0.2,4,1.3,5.2l15.8,17.3l-0.4,0.4c-1.4,1.4-2.1,2-2.4,2.2C124.6,106.7,124,109,123.4,111.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4589_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_134_",
    className: "st0",
    d: "M139.1,85.9l-1.2-1.5c-1-1.3-2-2.6-3.1-3.8l0.4-1.7c0.4-1.9-0.2-4.3-1.5-5.7l-2.2-2.4 c-0.6-0.7-1.3-1-1.9-0.9l0,0l-3.7,0.8c-1.1-1.1-2.1-2.2-3.2-3.2l-4.2-4c-0.6-0.6-1.2-0.8-1.8-0.8c-5.2,0.2-9.2,1.6-10.5,2.1 c-0.3,0.1-0.4,0.4-0.3,0.7l0.2,0.5l5.1,5l-3,2.7c-0.9,2.7,2.4,2.4,1.8,5.4l6.2,5.5l13,4.9c0,0,5.6-1.1,10.4-2.4 C139.6,86.7,139.4,86.3,139.1,85.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_136_",
    className: "st1",
    d: "M129.4,90.2L116,85.1l-6.4-5.8l0.1-0.4c0.2-1.2-0.2-1.6-0.8-2.2 c-0.7-0.7-1.5-1.5-0.9-3.2l0.2-0.3l2.5-2.3l-4.8-4.7l-0.2-0.5c-0.1-0.3-0.1-0.6,0-0.9c0.1-0.3,0.3-0.5,0.6-0.6 c1.5-0.6,5.5-2,10.7-2.1c0.7-0.1,1.6,0.2,2.3,0.9l4.2,4c1,1,2,2,3,3l3.4-0.7c0.7-0.1,1.5,0.1,2.5,1.1l2.2,2.4 c1.4,1.5,2,4.1,1.6,6.2l-0.3,1.4c1,1.2,1.9,2.4,2.9,3.6l1.2,1.5c0.3,0.4,0.6,0.8,0.8,1.3l0.3,0.7l-0.7,0.2 c-4.8,1.3-10.4,2.4-10.4,2.4L129.4,90.2z M116.7,84.1l12.8,4.8c0.9-0.2,5.3-1.1,9.4-2.2c-0.1-0.1-0.2-0.3-0.3-0.4l-1.2-1.5 c-1-1.3-2-2.6-3.1-3.8l-0.2-0.2l0.4-2c0.4-1.7-0.2-3.9-1.3-5.1l-2.2-2.4c-0.3-0.4-0.8-0.8-1.3-0.7l-4,0.8l-0.2-0.2 c-1.1-1.1-2.1-2.1-3.2-3.2l-4.2-4c-0.4-0.4-0.9-0.6-1.3-0.6c-4.9,0.1-8.7,1.4-10.2,2l0.1,0.3l5.5,5.4l-3.3,3 c-0.3,0.9,0.1,1.2,0.7,1.8c0.6,0.6,1.4,1.4,1.2,3L116.7,84.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4588_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_129_",
    className: "st0",
    d: "M133.8,73.3l-2.2-2.4c-0.6-0.7-1.3-1-1.9-0.9l-3.7,0.8l-6.2,1.3 c-0.3,0.1-0.4,0.4-0.3,0.6l2.4,4.9l12.9-2.6C134.5,74.4,134.2,73.8,133.8,73.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_130_",
    className: "st1",
    d: "M121.5,78.4l-2.6-5.4c-0.1-0.3-0.1-0.6,0-0.9c0.1-0.3,0.4-0.5,0.7-0.6l9.9-2 c0.6-0.1,1.5,0.1,2.5,1.1l2.2,2.4c0.4,0.5,0.8,1.1,1.1,1.8l0.3,0.7L121.5,78.4z M120.1,72.6l2.1,4.3l11.7-2.4 c-0.2-0.3-0.4-0.6-0.6-0.8h0l-2.2-2.4c-0.3-0.4-0.8-0.8-1.3-0.7L120.1,72.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4587_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_120_",
    className: "st0",
    d: "M129.6,95.5L130,94c0.4-1.9-0.2-4.3-1.3-5.8l-1.2-1.5c-1-1.3-2-2.6-3.1-3.8l0.4-1.7 c0.4-1.9-0.2-4.3-1.5-5.7l-2.2-2.4c-1.2-1.3-2.7-1.2-3.4,0.4l-0.6,1.2c-1.6-1.7-3.2-3.3-4.9-4.9l-4.2-4 c-1.3-1.2-2.7-1-3.4,0.6l-0.6,1.2c-1.9,4.2-3.4,8.9-4.4,14L99.4,83c-0.4,1.9,0.2,4.4,1.5,5.7l20.4,22.3 c1.2,1.4,2.7,1.2,3.4-0.4l0.5-1.2C127.1,105.3,128.6,100.6,129.6,95.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_121_",
    className: "st1",
    d: "M123,112.6c-0.8,0-1.5-0.4-2.2-1.1l-20.4-22.3c-1.4-1.5-2.1-4.2-1.6-6.3l0.3-1.4 c1.1-5.1,2.6-9.9,4.5-14.1l0.6-1.2c0.4-0.9,1.1-1.6,1.9-1.7c0.8-0.2,1.7,0.2,2.5,0.9l4.2,4c1.4,1.3,2.8,2.8,4.2,4.3l0.2-0.4 c0.4-0.9,1.1-1.5,1.9-1.6c0.9-0.1,1.8,0.3,2.5,1.1l2.2,2.4c1.4,1.5,2,4.1,1.6,6.2l-0.3,1.4c1,1.2,1.9,2.4,2.9,3.6l1.2,1.5 c1.3,1.6,1.9,4.2,1.5,6.3l-0.3,1.6c-1.1,5.1-2.6,9.9-4.5,14.1l-0.5,1.2c-0.4,0.9-1.1,1.5-1.9,1.6 C123.2,112.6,123.1,112.6,123,112.6z M106.4,65.6c-0.1,0-0.1,0-0.2,0c-0.4,0.1-0.8,0.4-1,1l-0.6,1.2 c-1.9,4.2-3.3,8.8-4.4,13.9l-0.3,1.4c-0.4,1.7,0.2,4,1.3,5.2l20.4,22.3c0.5,0.5,1,0.8,1.4,0.7c0.4-0.1,0.7-0.4,1-0.9l0.5-1.2 c1.9-4.2,3.3-8.8,4.4-13.9l0.3-1.6c0.4-1.7-0.1-3.9-1.2-5.3l-1.2-1.5c-1-1.3-2-2.6-3.1-3.8l-0.2-0.2l0.4-2 c0.4-1.7-0.2-3.9-1.3-5.1l-2.2-2.4c-0.5-0.5-1-0.8-1.4-0.7c-0.4,0.1-0.7,0.4-0.9,0.9l-0.9,2.1l-0.6-0.7 c-1.7-1.7-3.3-3.4-4.8-4.9l-4.2-4C107.2,65.8,106.8,65.6,106.4,65.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4586_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_113_",
    className: "st0",
    d: "M122.2,97.9c1.8-5.7,0-13.9-4-18.3c-1.9-2.1-4-2.9-5.8-2.7l0,0l0,0c-0.1,0-0.3,0-0.4,0.1 l-10.7,2.2l5.5,25.8l10.7-2.2c0.1,0,0.3,0,0.4-0.1l0,0l0,0C119.8,102.3,121.3,100.6,122.2,97.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_114_",
    className: "st1",
    d: "M106.3,105.8l-5.8-27.1l11.3-2.3c0.1,0,0.3-0.1,0.4-0.1c2.2-0.3,4.4,0.7,6.4,2.9 c4.1,4.5,6,13,4.1,18.9l0,0c-0.9,2.9-2.6,4.7-4.7,5.3c-0.2,0-0.3,0.1-0.5,0.1L106.3,105.8z M102,79.7l5.3,24.6l10.1-2.1 c0.1,0,0.2,0,0.3-0.1c1.7-0.5,3.1-2,3.9-4.5l0,0c1.7-5.5,0-13.4-3.9-17.6c-1.7-1.9-3.6-2.7-5.3-2.5c-0.1,0-0.3,0-0.4,0.1 L102,79.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4585_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_109_",
    className: "st0",
    d: "M122.3,87.9c-0.7-3.2-2.2-6.2-4.1-8.3c-1.9-2.1-4-2.9-5.8-2.7l-11.5,2.5l1.1,3.5l9.3,7.3 l10.7-2.2C122.1,87.9,122.2,87.9,122.3,87.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_110_",
    className: "st1",
    d: "M111.2,90.8l-9.7-7.6l-1.4-4.4l12.1-2.6c2.2-0.3,4.4,0.7,6.4,2.9 c1.9,2.1,3.5,5.2,4.3,8.6l0.1,0.6l-0.6,0.1l-0.1-0.6l0.1,0.6c-0.1,0-0.2,0-0.3,0.1L111.2,90.8z M102.6,82.5l8.9,7l10-2.1 c-0.8-3-2.1-5.6-3.8-7.4c-1.7-1.9-3.6-2.7-5.2-2.5l-10.7,2.3L102.6,82.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4582_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_103_",
    transform: "matrix(0.9767 -0.2146 0.2146 0.9767 -17.3465 24.4929)",
    className: "st0",
    cx: 104.1,
    cy: 92.1,
    rx: 7.6,
    ry: 13.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_104_",
    className: "st1",
    d: "M106,105.8c-1.9,0-3.8-1-5.6-2.9c-4.1-4.5-6-13-4.1-18.9c0.9-3,2.7-4.9,4.9-5.4 c2.2-0.5,4.6,0.5,6.7,2.8c4.1,4.5,6,13,4.1,18.9c-0.9,3-2.7,4.9-4.9,5.4C106.7,105.7,106.4,105.8,106,105.8z M102.3,79.7 c-0.3,0-0.6,0-0.8,0.1c-1.8,0.4-3.2,2-4,4.5c-1.7,5.5,0,13.4,3.9,17.6c1.8,2,3.7,2.8,5.5,2.4c1.8-0.4,3.2-2,4-4.5l0,0 c1.7-5.5,0-13.4-3.9-17.6C105.4,80.6,103.8,79.7,102.3,79.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4592_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_99_",
    transform: "matrix(0.9767 -0.2146 0.2146 0.9767 -17.3467 24.4933)",
    className: "st1",
    cx: 104.1,
    cy: 92.1,
    rx: 4,
    ry: 6.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_100_",
    className: "st1",
    d: "M105.1,99.5c-1.1,0-2.2-0.6-3.1-1.6c-2.3-2.5-3.2-6.9-2.2-10.1c0.5-1.7,1.5-2.7,2.8-3 c1.3-0.3,2.6,0.3,3.8,1.6c2.3,2.5,3.2,6.9,2.2,10.1l0,0c-0.5,1.7-1.5,2.7-2.8,3C105.5,99.5,105.3,99.5,105.1,99.5z M103.2,86 c-0.1,0-0.3,0-0.4,0c-0.8,0.2-1.5,0.9-1.9,2.2c-0.9,2.8,0,6.8,2,8.9c0.9,0.9,1.8,1.4,2.6,1.2c0.8-0.2,1.5-0.9,1.9-2.2l0,0 c0.9-2.8,0-6.8-2-8.9C104.6,86.4,103.9,86,103.2,86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4596_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_95_",
    className: "st0",
    d: "M107,88.5c-0.8-1.5-1.8-2.4-2.7-2.8c-0.8,0.8-1.3,2-1.4,3.9c-0.1,2,0.3,4,1.3,5.8 c0.8,1.5,1.6,2.3,2.6,2.7c0.8-0.8,1.5-2,1.6-3.8C108.4,92.3,107.9,90.3,107,88.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_96_",
    className: "st1",
    d: "M106.9,98.9l-0.4-0.2c-1.1-0.5-2-1.4-2.9-3c-1-1.8-1.5-4-1.4-6.1c0.1-1.9,0.6-3.4,1.6-4.3 l0.3-0.3l0.4,0.2c1.1,0.5,2.2,1.6,3,3.1v0c1,1.8,1.5,4,1.4,6.1c-0.1,1.7-0.7,3.2-1.7,4.2L106.9,98.9z M104.4,86.5 c-0.5,0.7-0.9,1.8-0.9,3.2c-0.1,1.9,0.3,3.8,1.2,5.4c0.6,1.1,1.2,1.9,1.9,2.3c0.7-0.8,1-1.9,1.1-3.1c0.1-1.9-0.3-3.8-1.2-5.4 C105.8,87.7,105.1,86.9,104.4,86.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4591_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_91_",
    className: "st0",
    cx: 95.9,
    cy: 60,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_92_",
    className: "st1",
    d: "M95.9,63.1c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1c1.7,0,3.1,1.4,3.1,3.1 C99,61.7,97.6,63.1,95.9,63.1z M95.9,58.1c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8 C97.7,59,96.9,58.1,95.9,58.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4594_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_81_",
    className: "st0",
    cx: 292.2,
    cy: 146.6,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_88_",
    className: "st1",
    d: "M292.2,149.7c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1c1.7,0,3.1,1.4,3.1,3.1 C295.3,148.3,293.9,149.7,292.2,149.7z M292.2,144.8c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8 C294,145.6,293.2,144.8,292.2,144.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1799_",
    className: "st1",
    d: "M120.8,128.7c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1c1.7,0,3.1,1.4,3.1,3.1 C123.9,127.3,122.5,128.7,120.8,128.7z M120.8,123.8c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8 S121.9,123.8,120.8,123.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4593_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4595_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_87_",
    x: 214.8,
    y: 35.7,
    className: "st1",
    width: 1.2,
    height: 7.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4597_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_86_",
    x: 211.3,
    y: 39,
    className: "st1",
    width: 8.2,
    height: 1.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3775_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3777_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_83_",
    x: 320.6,
    y: 83.8,
    className: "st1",
    width: 1.2,
    height: 7.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3776_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_82_",
    x: 317.1,
    y: 87.1,
    className: "st1",
    width: 8.2,
    height: 1.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1744_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st0",
    d: "M205.7,143.8h-3.1c-0.4,0-0.7-0.3-0.7-0.7V140c0-0.4,0.3-0.7,0.7-0.7h3.1 c0.4,0,0.7,0.3,0.7,0.7v3.1C206.4,143.5,206.1,143.8,205.7,143.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_78_",
    className: "st1",
    d: "M205.7,144.4h-3.1c-0.7,0-1.3-0.6-1.3-1.3V140c0-0.7,0.6-1.3,1.3-1.3h3.1 c0.7,0,1.3,0.6,1.3,1.3v3.1C207,143.8,206.4,144.4,205.7,144.4z M202.5,139.9l-0.1,3.2l3.2,0.1c0.1,0,0.1,0,0.1-0.1V140 L202.5,139.9z"
  }))))), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "674.5,503.9 643.7,502.1 668.5,304.1 692.4,317  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.e086a665ca1a24884ae1d3d2d15b45db.svg";
export { ForwardRef as ReactComponent };